import React, { useEffect, useState, useRef, Suspense } from 'react'

import MultipleFileUpload from '../Components/MultipleFileUpload'

import Timezone from '../../../src/Utility/Timezone';
import Utility from '../Utility'
import BootstrapSwitchButton from 'bootstrap-switch-button-react';
import moment from 'moment';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { loaderStateTrue, loaderStateFalse, handleActiveLink, setChatDocView } from '../../Actions/AllAction';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import ErrorBoundary from './ErrorBoundary';
import { chatHistoryList, starUpdate, followUpPost, customFieldListGet, alltemplateLists, ondemandTemplateLists, campaignBroadcastingPost, lastFromIdUpdate, userInformationUpdate, ContactsList, allgroupContactLists, getGroupAndContactList, clearChatHistory } from '../Controller/UtilityController'
import parsePhoneNumber from 'libphonenumber-js';
import PhoneInput from 'react-phone-input-2';
import EventEmitter from '../EventEmitter';
import ModalGlobal from './ModalGlobal';
import * as Store from '../../storeRedux';
import UtilityGlobal from '../../GlobalModules/Utility/Utility';
// const version = Object.keys(Store.default.getState().LoginReducer.userCredentials).length > 0 ? (Store.default.getState().LoginReducer.userCredentials.user_details.version).toUpperCase() == "" ? "V3.0.1" : (Store.default.getState().LoginReducer.userCredentials.user_details.version).toUpperCase() : "V3.0.1";
// // console.log('version-1--->',version)
// const ReEngageModalContent = React.lazy(() => import(`../../${version}/Modules/ChatHistory/Components/ReEngageModalContent`));
// const Chatpanel = React.lazy(() => import(`../../../src/${version}/Modules/ChatHistory/Components/Chatpanel`));
// const ChatHistoryInput = React.lazy(() => import(`../../../src/${version}/Modules/ChatHistory/Components/ChatHistoryInput`));
//const HomeUtility = React.lazy(() => import(`../../${version}/Modules/Template/Utility/Utility`));

import HomeUtility from '../HomeUtility';

import momentTimezone from 'moment-timezone';
import Config from '../../../src/Utility/Config';
import ConfirmationAlert from './ConfirmationAlert';
import WhatsAppDataFormate from '../../Utility/WhatsAppDataFormateV3/WhatsAppDataFormate';
import { Badge } from 'react-bootstrap';
import Popover from 'react-bootstrap/Popover';
import EmojiContent from '../../Utility/Components/EmojiContent';
import Overlay from 'react-bootstrap/Overlay';
import AutosuggestComponent from './AutosuggestComponent';

import { DebounceInput } from 'react-debounce-input';
import Select, { components as selectComponents, ValueContainerProps } from "react-select";
import { parsePhoneNumberFromString } from 'libphonenumber-js';



const CustomValueContainer = ({ children, ...props }) => {
    const values = props.getValue();
    const isTyping = props.selectProps.inputValue.length > 0;
    const showPlaceholder = values.length === 0 && !isTyping;

    const displayValues = values.slice(0, 4).map((val) => (
        <selectComponents.MultiValueContainer {...props} data={val} key={val.value}>
            <div className="dropdownValueBoxInner">
                <selectComponents.MultiValueLabel {...props} data={val}>
                    <span className='lable_value'>{(val.label).substring(0, 15) + "..."}</span>
                </selectComponents.MultiValueLabel>
                <span className='cross_btn' onClick={(e) => {
                    e.stopPropagation();
                    const newValue = values.filter((item) => item.value !== val.value);
                    props.selectProps.setParamsData({})
                    props.selectProps.onChange(newValue);
                }}
                >
                    &#10005;
                </span>
            </div>
        </selectComponents.MultiValueContainer>
    ));

    const moreLabel = values.length > 4 ? (
        <div className='add_more_btn'
            onClick={(e) => {
                e.stopPropagation();
                props.selectProps.handleOverflowClick();
            }}
        >
            +{values.length - 4} More
        </div>
    ) : null;

    return (
        <selectComponents.ValueContainer {...props} style={{ position: 'relative' }}>
            {showPlaceholder && (
                <div className='place_holder_text'>{props.selectProps.placeholder}</div>
            )}
            {displayValues}
            {moreLabel}
            {children[1]}
        </selectComponents.ValueContainer>
    );
};




const Menu = (props) => {
    return (
        <selectComponents.Menu {...props}>
            <div className="dropdowninnersection">
                <div className="dropdownlabelbtn">
                    <div className="dropheaderlabel">{props.selectProps.menuHeader}</div>
                </div>
                <div>{props.children}</div>
            </div>
        </selectComponents.Menu>
    );
};
function ChatHistoryModal(props) {
    // console.log("props==========", props.value)
    const allowedVersions = ["V3.0.1", "V4", "V5", "V6"];
    const [Chatpanel, setChatpanel] = useState(null);
    const [ReEngageModalContent, setReEngageModalContent] = useState(null);
    const [ChatHistoryInputModal, setChatHistoryInputModal] = useState(null);
    const [paramsData, setParamsData] = useState({});
    // const [paramsData, setParamsData] = useState(props?.paramsData || {});
    const [fileInputKey, setFileInputKey] = useState(Date.now());
    const [isLiveChat, setIsLiveChat] = useState(0);
    const [liveChatEndAt, setLiveChatEndAt] = useState("");
    const [checkedLiveMode, setCheckedLiveMode] = useState(localStorage.getItem('livemode_0') == "1" ? true : false);
    // const [chatHistoryData, setChatHistoryData] = useState(props.value && props.value == 11 ? props.chatHistoryData : []);
    const [chatHistoryData, setChatHistoryData] = useState(() => {
        if (props.value === 11 && props.chatHistoryData.length > 0) {
            return props.chatHistoryData;
        }
        if (props.value === -1 && props.chatHistoryData.length > 0 && props.gridPhoneNumber.includes("**")) {
            return props.chatHistoryData;
        }
        return [];
    });
    const [scrollInFirstTime, setscrollInFirstTime] = useState(false);
    const messageRef = useRef();
    const chatContainerRef = useRef(null);
    const [reEngageModalFlag, setReEngageModalFlag] = useState(false);
    const [twentyfourshoursover, setTwentyfourshoursover] = useState(false);
    const [fileUploadFNFlag, setfileUploadFNFlag] = useState(false);
    const [chatHistoryInput, setChatHistoryInput] = useState('');
    const [chatHistoryDocumentObject, setChatHistoryDocumentObject] = useState([]);
    const [chatHistoryDocumentObjName, setChatHistoryDocumentObjName] = useState("Choose file");
    const [emojiInputType, setEmojiInputType] = useState("");
    const [emojiShowFlag, setEmojiShowFlag] = useState(false);
    const [chatcount, setchatcount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [chatModeSection, setChatModeSection] = useState(true);
    const [chatModeParamsData, setChatModeParamsData] = useState({});
    const [phoneNumber, setPhoneNumber] = useState(props.gridPhoneNumber != "" ? props.gridPhoneNumber : "");
    const [phoneNumberInput, setPhoneNumberInput] = useState(props.gridPhoneNumber != "" ? props.gridPhoneNumber : "");
    const [phoneNumberError, setPhoneNumberError] = useState("");


    const [selectedCountryCode, setSelectedCountryCode] = useState("in");
    const [phoneNumberCountryCode, setPhoneNumberCountryCode] = useState("in");
    const [phoneNumberDialCode, setPhoneNumberDialCode] = useState("91");

    const [lastMessageDate, setLastMessageDate] = useState("");
    const [selectedUserData, setSelectedUserData] = useState({})
    const [scrollblockFlag, setscrollblockFlag] = useState(false);
    const [isChatListPage, setIsChatListPage] = useState(false);

    const [selectedTimezoneType, setSelectedTimezoneType] = useState({ label: "Select Timezone", value: "selecttimezone" });
    const [selectedTimezoneDataError, setSelectedTimezoneDataError] = useState("")
    const [selectedDateTimeForReEngage, setSelectedDateTimeForReEngage] = useState("");
    const [selectedTemplateData, setSelectedTemplateData] = useState([])
    const [selectedTemplateDataError, setSelectedTemplateDataError] = useState("")
    const [preValueDynamicUrl, setPreValueDynamicUrl] = useState({})
    const [templateListData, setTemplateListData] = useState([]);
    const [fieldTypeList, setFieldTypeList] = useState([])
    const [dynamicCheckboxChecked, setDynamicCheckboxChecked] = useState(false);
    const [isPreviousVal, setisPreviousVal] = useState(false);
    const [previousVal, setpreviousVal] = useState([]);
    const [previousValUrl, setpreviousValUrl] = useState([]);
    const [isPreviousValUrl, setisPreviousValUrl] = useState(false);
    const [mediaUrl, setMediaUrl] = useState("");
    const [dynamicUrlError, setDynamicUrlError] = useState("");
    const [mediaUrlError, setMediaUrlError] = useState("");
    const [zoominzoomoutflag, setZoominzoomoutflag] = useState("");
    const [reanderUI, setReander] = useState(false);
    const [selectedDateTime, setSelectedDateTime] = useState("");
    const [confirmationForReEngageModalFlag, setConfirmationForReEngageModalFlag] = useState(false);
    const [checkedInboxMode, setCheckedInboxMode] = useState(localStorage.getItem('switchmode_0') == "1" ? true : false);
    const [scheduleMessageModalFlag, setScheduleMessageModalFlag] = useState(false);
    const [scheduleMessageParamsData, setScheduleMessageParamsData] = useState({});
    const [enableFlag, setEnableFlag] = useState(false);
    const [templateMessageType, setTemplateMessageType] = useState("");
    const [uploadFilePopupFlag, setUploadFilePopupFlag] = useState(false);
    const targetFileUpload = useRef(null);
    const [chatmodeListMember, setChatmodeListMember] = useState([]);
    const [initialSetPhoneNumber, setInitialSetPhoneNumber] = useState(true);
    const [activeTab, setActiveTab] = useState('singleUser');
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [additionalContactsOptions, setadditionalContactsOptions] = useState([]);
    const [additionalContactSelectedValue, setadditionalContactSelectedValue] = useState([]);
    const [selectedGroupContact, setSelectedGroupContact] = useState([])
    const [groupContactsData, setGroupContactsData] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const inputContainerRef = useRef(null);
    const [messagesViewClickStatusData, setMessagesViewClickStatusData] = useState([]);
    const phoneInputRef = useRef(null);
    const suggestionsRef = useRef(null);

    const [gropuAndPhoneNumberList, setGropuAndPhoneNumberList] = useState([]);
    const [selectedGroupAndPhoneNumber, setSelectedGroupAndPhoneNumber] = useState([]);
    const [searchingData, setSearchingData] = useState("");
    const [isModalOpen, setModalOpen] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    //Template message/mobile view
    const [selectedTabTemplate, setSelectedTabTemplate] = useState("broadcast_template");
    const [mobileTemplateListData, setMobileTemplateListData] = useState([]);
    const [noRecordFoundMsg, setNoRecordFoundMsg] = useState();
    const [hasMoreMobileTemplateList, setHasMoreMobileTemplateList] = useState(false);
    const [cardTemplateOffsets, setCardTemplateOffsets] = useState(0);
    const [cardTemplateLimits, setCardTemplateLimits] = useState(10);
    const [templateName, setTemplateName] = useState("");
    const [clearTemplateSearchDataStatus, setClearTemplateSearchDataStatus] = useState(false);
    const [pageRefresh, setPageRefresh] = useState(false);
    const [messagesViewClickStatus, setMessagesViewClickStatus] = useState(false);
    const [permissionModeOnly, setPermissionModeOnly] = useState(false);

    //chat history delete
    const [chatHistoryDeleteConfirmationFlag, setChatHistoryDeleteConfirmationFlag] = useState(false);
    const [scrollAtEnd, setScrollAtEnd] = useState(false);


    const [actionClick, setActionClick] = useState(false);
    const [rolePermissions, setRolePermissions] = useState({
        leads: "",
        opportunity: "",
        futureOpportunity: "",
        inactive: "",
    });
    // const [selectedEmoji, setSelectedEmoji] = useState(null); 


    const [selectedView, setSelectedView] = useState('card_view');
    const [selectedUser, setSelectedUser] = useState({});
    const [disableFilter, setDisableFilter] = useState(false);
    const dropdownRef = useRef(null);


    // templateTypeList: [
    //     { label: "Approved", value: 'APPROVED' },
    //     { label: "Rejected", value: 'REJECTED' },
    //     { label: "Pending", value: 'PENDING' },
    // ],
    // template_type_filter: "",


    let roleName = props.userCredentials.hasOwnProperty('user_details') && props.userCredentials.user_details && props.userCredentials.user_details.hasOwnProperty('user_type') && props.userCredentials.user_details.user_type;
    let user_first_name = paramsData && paramsData.hasOwnProperty('profile_name') && paramsData.profile_name && paramsData.profile_name != "" ? paramsData?.profile_name?.trim()?.split(" ")[0] : ""
    // let user_last_name = paramsData && paramsData?.profile_name && paramsData?.profile_name != "" ? paramsData?.profile_name?.trim()?.split(" ")[1] : ""
    let user_last_name = paramsData && paramsData.hasOwnProperty('profile_name') && paramsData.profile_name && paramsData.profile_name != "" ? paramsData?.profile_name?.trim()?.split(" ")[1] : "";
    const firstInitial = user_first_name?.trim().charAt(0) || '';
    const lastInitial = user_last_name?.trim().charAt(0) || '';


    useEffect(() => {
        const loadComponent = async () => {
            const rawVersion = Store.default.getState().LoginReducer.userCredentials?.user_details?.version;
            const userVersion = typeof rawVersion === "string" ? rawVersion.toUpperCase() : null;
            const version = allowedVersions.includes(userVersion) ? userVersion : "V3.0.1";
            try {
                const module = await import(`../../../src/${version}/Modules/ChatHistory/Components/Chatpanel`);
                setChatpanel(() => module.default);
                const moduleReengage = await import(`../../../src/${version}/Modules/ChatHistory/Components/ReEngageModalContent`);
                setReEngageModalContent(() => moduleReengage.default);
                const moduleChat = await import(`../../../src/${version}/Modules/ChatHistory/Components/ChatHistoryInput`);
                setChatHistoryInputModal(() => moduleChat.default);
            } catch (error) {
                console.error("Failed to load Chatpanel:", error);
            }
        };

        loadComponent();
    }, []);

    useEffect(() => {
        if (!props.globalChat) {
            setDisableFilter(true)
        }
    }, [props.globalChat])

    useEffect(() => {
        checkRolePermission()
    }, [])

    useEffect(() => {
        // console.log("props.gridPhoneNumber======", props.gridPhoneNumber)
        if (props.gridPhoneNumber && props.gridPhoneNumber != "" && initialSetPhoneNumber) {
            if (props.globalChatName != "") {
                setSelectedUser({ ...selectedUser, 'phone_number': props.gridPhoneNumber, 'profile_name': props.globalChatName })
            } else {
                setSelectedUser({ 'phone_number': props.gridPhoneNumber })
            }
            // getUserDataFromPhoneNumberApiFn()
            setPhoneNumber(props.gridPhoneNumber)
        }


    }, [props.gridPhoneNumber])

    useEffect(() => {
        if (props.globalChat) {
            let phone = props.userCredentials?.user_details?.whatsapp_business_phone_number;
            if (phone && phone.trim().length > 3) {
                const normalized = phone.startsWith("+") ? phone : "+" + phone;
                const parsed = parsePhoneNumberFromString(normalized);
                if (parsed && parsed.isValid()) {
                    setPhoneNumberDialCode(parsed.countryCallingCode);
                    setSelectedCountryCode(parsed.country?.toLowerCase());
                } else {
                    setPhoneNumberDialCode("");
                    setSelectedCountryCode("");
                }
            }
        }
    }, [props.userCredentials]);

    useEffect(() => {
        if (props.groupMessage) {
            setPhoneNumber('')
            setChatModeParamsData({})
            setParamsData({})
            setChatHistoryData([])
            setTwentyfourshoursover(true);
            setActiveTab('userGroup')
            setDisableFilter(false)
        }
    }, [props.groupMessage])

    useEffect(() => {
        if (Object.keys(props.groupMessageData).length > 0) {
            let groupArr = []
            let group_hash = {}
            group_hash['label'] = `${props.groupMessageData?.name}${props.groupMessageData.hasOwnProperty('members_count') && props.groupMessageData.members_count && Number(props.groupMessageData.members_count) > 0 ? `(${props.groupMessageData.hasOwnProperty('members_count') && props.groupMessageData.members_count && Number(props.groupMessageData.members_count) > 1 ? 'contacts:' : 'contact:'}${props.groupMessageData.hasOwnProperty('members_count') && props.groupMessageData.members_count ? props.groupMessageData.members_count : '0'})` : '(No contact)'}`
            group_hash['value'] = props.groupMessageData?.id
            group_hash['type'] = "group"
            groupArr.push(group_hash);
            setGropuAndPhoneNumberList(groupArr)
            setSelectedGroupContact(groupArr)
        }
    }, [props.groupMessageData])

    useEffect(() => {
        if (props.lastChatInitiatedAt != "") {
            // console.log("props.lastChatInitiatedAt =====>Entry")
            checkDateTimeHoursOverOrNot(props.lastChatInitiatedAt);
        }

        // console.log("props.lastChatInitiatedAt =====>", props.lastChatInitiatedAt)
    }, [props.lastChatInitiatedAt])


    const getUserDataFromPhoneNumberApiFn = () => {
        // console.log("getUserDataFromPhoneNumberApiFn>")
        let phoneValidate = HomeUtility.validate_Phone_Number_without_plus(phoneNumber);
        // console.log("phoneValidate===========", phoneValidate)
        if (phoneValidate) {
            props.loaderStateTrue();
            let filters = {};
            let globalQueryParamshash = {};
            globalQueryParamshash["phone_number"] = phoneNumber.replace("+", "")
            globalQueryParamshash["org_id"] = props.userCredentials.user_details.org_id
            globalQueryParamshash["group_by"] = true
            filters['filters'] = JSON.stringify(globalQueryParamshash);

            if (typeof phoneNumber !== "undefined" && phoneNumber !== null) {
                chatHistoryList(filters).then((response) => {
                    // console.log("filters=======", response)
                    if (response.success) {
                        setReander(true);
                        setEnableFlag(true)
                        setChatHistoryInput("")
                        getUserDetailsFn();
                        if (response.hasOwnProperty('data') && response.data && response.data.length > 0) {
                            let tempParamsData = response.data[0];
                            setParamsData(tempParamsData)
                            setChatModeParamsData(tempParamsData)
                            setIsLiveChat(tempParamsData.hasOwnProperty('is_live_chat') && tempParamsData.is_live_chat ? tempParamsData.is_live_chat : 0)
                            setCheckedLiveMode(tempParamsData.is_live_chat == 1)
                            setLiveChatEndAt(tempParamsData.live_chat_ends_at)
                            setscrollblockFlag(true);
                            setIsChatListPage(true);
                            getLastToMessage(tempParamsData);
                            setTemplateMessageType("text_message")
                            setadditionalContactSelectedValue([{ "label": `${phoneNumber}(${tempParamsData.hasOwnProperty('profile_name') && tempParamsData.profile_name ? tempParamsData.profile_name : ""})`, value: phoneNumber }])
                            let chat_date = tempParamsData.hasOwnProperty('CustomerDetails') && tempParamsData.CustomerDetails && tempParamsData.CustomerDetails.hasOwnProperty('last_chat_initiated_at') && tempParamsData.CustomerDetails.last_chat_initiated_at ? tempParamsData.CustomerDetails.last_chat_initiated_at : "";
                            if (chat_date != "") {
                                checkDateTimeHoursOverOrNot(chat_date)
                            }
                        } else {
                            // console.log("twentyfourshoursover==========Entry 1")
                            setParamsData({})
                            setTwentyfourshoursover(true)
                        }

                    } else {
                        Utility.toastNotifications("Something went wrong !", "Error", "error")
                    }
                    props.loaderStateFalse();
                    setInitialSetPhoneNumber(false)
                    setChatHistoryDocumentObject([]);
                    setChatHistoryInput("");
                    setfileUploadFNFlag(false);
                }).catch((error) => {
                    props.loaderStateFalse();
                    setChatHistoryDocumentObject([]);
                    setChatHistoryInput("");
                    setfileUploadFNFlag(false);
                });
            } else {
                props.loaderStateFalse();
                setTwentyfourshoursover(false);
                setParamsData({})
                setChatHistoryInput("")
                setChatHistoryDocumentObject([]);
                setChatHistoryInput("");
                setfileUploadFNFlag(false);
                Utility.toastNotifications("Enter valid phone number", "Warning", "warning")
            }
        } else if (!phoneValidate && Utility.isCountryCodePhoneNumber(props.paramsData.phone_number)) {
            props.loaderStateTrue();
            let filters = {};
            let globalQueryParamshash = {};
            globalQueryParamshash["phone_number"] = props.paramsData.phone_number
            globalQueryParamshash["org_id"] = props.userCredentials.user_details.org_id
            globalQueryParamshash["group_by"] = true
            filters['filters'] = JSON.stringify(globalQueryParamshash);

            if (typeof phoneNumber !== "undefined" && phoneNumber !== null) {
                chatHistoryList(filters).then((response) => {
                    // console.log("filters=======", response)
                    if (response.success) {
                        setReander(true);
                        setEnableFlag(true)
                        setChatHistoryInput("")
                        getUserDetailsFn();
                        if (response.hasOwnProperty('data') && response.data && response.data.length > 0) {
                            let tempParamsData = response.data[0];
                            // console.log("tempParamsData=======", tempParamsData)
                            setParamsData(tempParamsData)
                            setChatModeParamsData(tempParamsData)
                            setIsLiveChat(tempParamsData.hasOwnProperty('is_live_chat') && tempParamsData.is_live_chat ? tempParamsData.is_live_chat : 0)
                            setCheckedLiveMode(tempParamsData.is_live_chat == 1)
                            setLiveChatEndAt(tempParamsData.live_chat_ends_at)
                            setscrollblockFlag(true);
                            setIsChatListPage(true);
                            getLastToMessage(tempParamsData);
                            setTemplateMessageType("text_message")
                            setadditionalContactSelectedValue([{ "label": `${tempParamsData.phone_number}(${tempParamsData.hasOwnProperty('profile_name') && tempParamsData.profile_name ? tempParamsData.profile_name : ""})`, value: tempParamsData.phone_number }])
                            let chat_date = tempParamsData.hasOwnProperty('CustomerDetails') && tempParamsData.CustomerDetails && tempParamsData.CustomerDetails.hasOwnProperty('last_chat_initiated_at') && tempParamsData.CustomerDetails.last_chat_initiated_at ? tempParamsData.CustomerDetails.last_chat_initiated_at : "";
                            if (chat_date != "") {
                                checkDateTimeHoursOverOrNot(chat_date)
                            }
                        } else {
                            // console.log("twentyfourshoursover==========Entry 1")
                            setParamsData({})
                            setTwentyfourshoursover(true)
                        }

                    } else {
                        Utility.toastNotifications("Something went wrong !", "Error", "error")
                    }
                    props.loaderStateFalse();
                    setInitialSetPhoneNumber(false)
                    setChatHistoryDocumentObject([]);
                    setChatHistoryInput("");
                    setfileUploadFNFlag(false);
                }).catch((error) => {
                    props.loaderStateFalse();
                    setChatHistoryDocumentObject([]);
                    setChatHistoryInput("");
                    setfileUploadFNFlag(false);
                });
            } else {
                props.loaderStateFalse();
                setTwentyfourshoursover(false);
                setParamsData({})
                setChatHistoryInput("")
                setChatHistoryDocumentObject([]);
                setChatHistoryInput("");
                setfileUploadFNFlag(false);
                Utility.toastNotifications("Enter valid phone number", "Warning", "warning")
            }
        } else {
            Utility.toastNotifications("Enter valid phone number", "Warning", "warning")
        }
    }


    const handleClickOutside = (event) => {
        if (inputContainerRef.current && !inputContainerRef.current.contains(event.target)) {
            setShowSuggestions(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if (additionalContactsOptions.length > 0) {
            setShowSuggestions(true)
        }
    }, [additionalContactsOptions])

    useEffect(() => {
        if (Object.keys(paramsData).length > 0) {
            chatHistoryGetApiCall();
        }
    }, [paramsData])

    const getLastToMessage = (activeUserData) => {
        console.log("activeUserData=======", activeUserData)
        let filters = {};
        let globalQueryParamshash = {};
        globalQueryParamshash["phone_number"] = activeUserData.phone_number.replace("+", "");
        globalQueryParamshash["limit"] = 10;
        globalQueryParamshash["offset"] = 0;

        filters['filters'] = JSON.stringify(globalQueryParamshash);
        props.loaderStateTrue();
        chatHistoryList(filters).then((response) => {
            props.loaderStateFalse();
            // const maxChatId = _.maxBy(response.data.filter(m => m.message_type == "from"), 'id');
            // let tempParamsData = response.hasOwnProperty('data') && response.data && response.data.length > 0 ? response.data[0] : {};
            // console.log('tempParamsData----->',tempParamsData)
            // let chat_date = tempParamsData.hasOwnProperty('CustomerDetails') && tempParamsData.CustomerDetails && tempParamsData.CustomerDetails.hasOwnProperty('last_chat_initiated_at') && tempParamsData.CustomerDetails.last_chat_initiated_at ? tempParamsData.CustomerDetails.last_chat_initiated_at : "";
            // checkDateTimeHoursOverOrNot(chat_date)
            setSelectedUserData(activeUserData)
        }).catch((error) => {
            props.loaderStateFalse();
        });
    }

    const getUserDetailsFn = () => {
        const { loaderStateFalse, loaderStateTrue } = props
        let filters = {};
        let filter_op = {};
        let globalQueryParamshash = {};
        if (props.searchValue != "") {
            globalQueryParamshash['search_attr'] = phoneNumber
            filter_op = Object.assign(filter_op, { "search_attr": "substring" });
        }
        if (Object.keys(filter_op).length > 0) {
            filters["filter_op"] = JSON.stringify(filter_op);
        }
        filters['filters'] = JSON.stringify(globalQueryParamshash)

        ContactsList(filters, "get").then((response) => {
            loaderStateFalse();
            if (response.success) {
                // console.log(response)
                if (response.data.length > 0) {
                    let phoneValidate = HomeUtility.validate_Phone_Number_without_plus(phoneNumber);
                    if (phoneValidate) {
                        // let user = {}
                        // user['profile_name'] = response.data[0]?.name
                        // user['phone_number'] = response.data[0]?.phone_number
                        // setParamsData(user)
                        // setChatModeParamsData(user)
                        checkDateTimeHoursOverOrNot(response.data[0]?.last_chat_initiated_at)
                    } else if (Utility.isCountryCodePhoneNumber(props.paramsData.phone_number) && !phoneValidate) {
                        checkDateTimeHoursOverOrNot(response.data[0]?.last_chat_initiated_at)
                    } else {
                        setParamsData({})
                    }
                } else {
                    // setParamsData({})
                }
            } else {
                Utility.toastNotifications("Something went wrong !", "Error", "error")
            }
            loaderStateFalse();
        }).catch((error) => {
            loaderStateFalse();
        });
    }

    const checkDateTimeHoursOverOrNot = (lastToMessageDate) => {
        // console.log("========lastToMessageDate======", lastToMessageDate)
        if (lastToMessageDate != null) {
            let parsedDate = moment(lastToMessageDate, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY hh:mm:ss A');
            parsedDate = moment(`${Timezone.formatDateForChatList(parsedDate, props.localTimeZoneName)}`, 'DD-MM-YYYY hh:mm:ss A').format('YYYY-MM-DD HH:mm:ss')
            // console.log("========parsedDate======", parsedDate)
            let duration = moment.duration(moment().diff(parsedDate));
            let hoursDifference = duration.asHours();
            // console.log("========hoursDifference======", hoursDifference)

            if (hoursDifference < 24) {
                // console.log("twentyfourshoursover==========Entry 1")
                setTwentyfourshoursover(false);
                setLastMessageDate(lastToMessageDate);
            } else {
                // console.log("twentyfourshoursover==========Entry 2")
                setTwentyfourshoursover(true);
            }
        } else {
            // console.log("twentyfourshoursover==========Entry 3")
            setTwentyfourshoursover(true);
        }
    }



    // Function to blend two colors
    const blendColors = (color1, color2) => {
        const rgb1 = hexToRgb(color1);
        const rgb2 = hexToRgb(color2);

        // Average the RGB values
        const r = Math.floor((rgb1.r + rgb2.r) / 2);
        const g = Math.floor((rgb1.g + rgb2.g) / 2);
        const b = Math.floor((rgb1.b + rgb2.b) / 2);

        return rgbToHex(r, g, b);
    }

    const getRandomLightColor = () => {
        const r = Math.floor(Math.random() * 156) + 100;
        const g = Math.floor(Math.random() * 156) + 100;
        const b = Math.floor(Math.random() * 156) + 100;
        return `rgb(${r}, ${g}, ${b})`;
    }
    // Function to convert hex to RGB
    const hexToRgb = (hex) => {
        let bigint = parseInt(hex.slice(1), 16);
        let r = (bigint >> 16) & 255;
        let g = (bigint >> 8) & 255;
        let b = bigint & 255;
        return { r, g, b };
    }

    // Function to convert RGB to hex
    const rgbToHex = (r, g, b) => {
        return (
            "#" +
            ((1 << 24) + (r << 16) + (g << 8) + b)
                .toString(16)
                .slice(1)
                .toUpperCase()
        );
    }

    const getRandomBackgroundColor = (user_name) => {
        const colors = {
            A: "#1abc9c",
            B: "#2ecc71",
            C: "#3498db",
            D: "#9b59b6",
            E: "#34495e",
            F: "#f1c40f",
            G: "#e67e22",
            H: "#e74c3c",
            I: "#95a5a6",
            J: "#16a085",
            K: "#27ae60",
            L: "#2980b9",
            M: "#8e44ad",
            N: "#2c3e50",
            O: "#f39c12",
            P: "#d35400",
            Q: "#c0392b",
            R: "#bdc3c7",
            S: "#7f8c8d",
            T: "#f39c12",
            U: "#d35400",
            V: "#c0392b",
            W: "#bdc3c7",
            X: "#7f8c8d",
            Y: "#16a085",
            Z: "#27ae60"
        };
        // console.log("user_name======",user_name)
        if (user_name != '') {
            const nameParts = user_name?.split(" ").filter(Boolean).slice(0, 2);
            const initials = nameParts?.map(part => part.charAt(0).toUpperCase()).join("");
            const initialsLength = initials?.length;
            const firstLetter = nameParts && nameParts[0]?.charAt(0).toUpperCase();
            let target_color = colors[firstLetter] || "#7f8c8d";
            if (initialsLength > 1) {
                const fl = initials?.split("")[0]
                const ll = initials?.split("")[1]
                const flc = colors[fl] || "#7f8c8d"
                const llc = colors[ll] || "#7f8c8d"
                target_color = blendColors(flc, llc);
            }
            // console.log("target_color======",target_color)
            return target_color;
        } else {
            let blackBackgroundColor = '#000';
            return blackBackgroundColor;
        }
    }

    const getRandomTextColor = () => {
        // const r = Math.floor(Math.random() * 256);
        // const g = Math.floor(Math.random() * 256);
        // const b = Math.floor(Math.random() * 256);
        // return `rgb(${r}, ${g}, ${b})`;
        let whiteTextColor = '#FFFFFF';
        return whiteTextColor;
    }

    const loadChat = () => {
        chatHistoryGetApiCall("chatloading");
    }
    const chatHistoryGetApiCall = (data) => {
        setLoading(true);
        let filters = {};
        let globalQueryParamshash = {};
        //globalQueryParamshash["phone_number"] = chatModeSection ? chatModeParamsData.phone_number : paramsData.phone_number;
        globalQueryParamshash["phone_number"] = phoneNumber.replace("+", "");
        globalQueryParamshash["limit"] = 10;
        if (Utility.isCountryCodePhoneNumber(paramsData.phone_number)) {
            setChatModeParamsData(paramsData)
        }
        if (data == "chatloading") {
            setchatcount(0)
            setChatHistoryData([]);
            setCurrentPage(1);
            setLoading(false);
            setscrollInFirstTime(false);
            globalQueryParamshash["offset"] = 0;
        } else {
            // globalQueryParamshash["offset"] = chatModeSection ? 0 : `${(currentPage - 1) * 10}`;
            globalQueryParamshash["offset"] = ((currentPage - 1) * 10);
        }

        filters['filters'] = JSON.stringify(globalQueryParamshash);
        props.loaderStateTrue();
        chatHistoryList(filters).then((response) => {
            if (response.success) {
                setchatcount(response.total)
                //setChatHistoryData();
                let reverseData = response.data.reverse();
                // let reverseData = response.data;
                reverseData = reverseData.map(item => ({
                    ...item,
                    contextMenu: {
                        visible: false,
                        x: 0,
                        y: 0,
                    },
                    reaction: '',
                }));
                setChatHistoryData(prevRes => [...reverseData, ...prevRes]);
                setCurrentPage(prevPage => prevPage + 1);
                setLoading(false);

            } else {
                Utility.toastNotifications("Something went wrong !", "Error", "error")
            }
            props.loaderStateFalse();
            const fromMessages = response.data
                .filter(message => message.message_type === "from")
                .sort((a, b) => new Date(b.chat_date) - new Date(a.chat_date)); // sort descending by date

            const lastFromMessage = fromMessages[0]; // first item = latest
            // const toMessages = response.data.filter(message => message.message_type === "to");
            // const lastToMessage = toMessages[toMessages.length - 1];
            // setLastToMessageDate(lastToMessage.chat_date)
            // console.log("userLoginDetails==========",props.userLoginDetails.user_type)
            if (lastFromMessage != null) {
                // setIsLastUpdatedFromId(true)
                lastFromIdPatchApiCall(lastFromMessage)
            }
        }).catch((error) => {
            props.loaderStateFalse();
        });
    }

    useEffect(() => {
        const listenerMsgStatus = EventEmitter.addListener("message_seen", (message) => {
            // this.unreadMsgCountApi();
            // const memberListToUpdate = Object.assign([], memberList)
            // markUserAsRead(message.phone_number);
            // memberListToUpdate.map(m => {

            //     const tempobj = Object.assign({}, m)
            //     if (m.phone_number == message.phone_number) {
            //         tempobj.unread_count = 0;
            //     }
            //     return tempobj;
            // })
            // setMemberList(memberListToUpdate);
        })
        const listener = EventEmitter.addListener("receivedMessage", (message) => {
            if (props.userCredentials.user_details.org_id == message[0].org_id) {
                if (chatModeSection) {
                    let socketPhoneNumberLength = message[0].phone_number.length;
                    let paramsPhoneNumberLength = chatModeSection ? chatModeParamsData.phone_number.length : paramsData.phone_number.length;
                    let sameNumberCheck = paramsPhoneNumberLength - socketPhoneNumberLength;
                    if (chatModeSection) {
                        // getInboxModeMemberList(selectedDayRange, 0);
                        if (message[0].phone_number == chatModeParamsData.phone_number.substring(sameNumberCheck)) {
                            // chatHistoryGetApiCall();
                            getLastToMessage(chatModeParamsData)
                            if (message[0].message_type === "from") {
                                lastFromIdPatchApiCall(message[0])
                                // beepAudioRef.current.play();
                            }
                            setChatHistoryData(prevRes => [...prevRes, ...message]);
                        }
                    } else {
                        if (message[0].phone_number == paramsData.phone_number.substring(sameNumberCheck)) {
                            // chatHistoryGetApiCall();
                            getLastToMessage(paramsData)
                            if (message[0].message_type === "from") {
                                lastFromIdPatchApiCall(message[0])
                                // beepAudioRef.current.play();
                            }
                            setChatHistoryData(prevRes => [...prevRes, ...message]);
                        }
                    }
                }
            }
        })
        return () => {
            listener.remove();
            listenerMsgStatus.remove();
        };

    }, [paramsData, chatModeSection, chatModeParamsData]);


    const lastFromIdPatchApiCall = (lastFromMessage) => {
        // console.log("lastFromMessage======", lastFromMessage)
        if (props.userLoginDetails.user_type == "support_user") {
            return;
        }
        const lastFromId = lastFromMessage ? lastFromMessage.id : null;
        let data = {};
        data["wa_status"] = "read";
        props.loaderStateTrue();
        lastFromIdUpdate(lastFromId, data).then((response) => {
            if (response.success) {
                EventEmitter.emit("message_seen", lastFromMessage)
            } else {
                console.log("Something went wrong !");
            }
            props.loaderStateFalse();
        }).catch((error) => {
            props.loaderStateFalse();
        });

    }

    const handleScroll = (e) => {

        const { scrollTop, clientHeight, scrollHeight } = e.currentTarget;
        // console.log("scrollTop=======", scrollTop)
        // console.log("chatHistoryData=======", chatHistoryData)
        // console.log("chatcount=======", chatcount)

        if (scrollTop === 0) {
            if (chatHistoryData.length < chatcount) {
                setscrollInFirstTime(true);
                chatHistoryGetApiCall();
                //setscrollblockCenter(true);
            }
            //setscrollblockFlag(false)
        }
    }

    useEffect(() => {
        // console.log('actionClick-------->', actionClick)
    }, [actionClick])


    const updateStarMark = (id, star) => {
        let data = {};
        data["star"] = star == 1 ? 0 : 1;
        setCurrentPage(1)
        props.loaderStateTrue();
        starUpdate(id, data).then((response) => {
            if (response.success) {
                Utility.toastNotifications(response.message, "Success", "success")
                starUpdateInChatList(id, data["star"]);
            } else {
                Utility.toastNotifications("Something went wrong !", "Error", "error")
            }
            props.loaderStateFalse();
        }).catch((error) => {
            console.log('----------error-------', error);

            props.loaderStateFalse();
        });
    }

    const starUpdateInChatList = (Id, newValue) => {
        let chatHistoryDataTemp = [...chatHistoryData];
        let objectToUpdate = chatHistoryDataTemp.find(item => item.id === Id);
        objectToUpdate.star = newValue;
        let updatedArray = chatHistoryDataTemp.map(item =>
            item.id === Id ? objectToUpdate : item);
        setChatHistoryData(updatedArray)
    }

    const messageActionCallBackOuteSideClick = () => {
        // console.log("Entry=========biplab 0")
        let chatHistoryDataTemp = [...chatHistoryData];
        // console.log("Entry=========biplab 0.0", chatHistoryDataTemp)

        chatHistoryDataTemp.forEach(item => {
            if (item.contextMenu.visible === true) {
                item.contextMenu = {
                    visible: false,
                    x: 0,
                    y: 0
                };
            }
        });

        // console.log("Entry=========biplab 1", chatHistoryDataTemp)

        setChatHistoryData(chatHistoryDataTemp)
    }

    const messageActionCallBack = (obj = {}, idx = '', type = '') => {
        // console.log("Entry=========biplab 2")
        let chatHistoryDataTemp = [...chatHistoryData];
        // console.log("Entry=========biplab 2.0.0", chatHistoryDataTemp)
        let objectToUpdate = chatHistoryDataTemp.find(item => item.id === idx);
        objectToUpdate.contextMenu = obj;
        let updatedArray = chatHistoryDataTemp.map(item =>
            item.id === idx ? objectToUpdate : {
                ...item, contextMenu: {
                    visible: false,
                    x: 0,
                    y: 0
                }
            });

        // console.log("Entry=========biplab 2.0", updatedArray)
        setChatHistoryData(updatedArray)

    }

    const scrollToBottom = () => {

        // console.log("scrollInFirstTime=======0", actionClick)
        if (chatContainerRef.current) {
            const chatContainer = chatContainerRef.current;
            // console.log("scrollInFirstTime=======", scrollInFirstTime)
            if (!scrollInFirstTime) {
                // console.log("scrollInFirstTime=======1")
                chatContainer.scrollTop = chatContainer.scrollHeight;
            }
            // else if (actionClick) {
            //     console.log("scrollInFirstTime=======2")
            //     chatContainer.scrollTop = 0
            //     //setActionClick(false)
            // }
            else {
                // console.log("scrollInFirstTime=======3")
                chatContainer.scrollTop = 350
            }
        }

    };

    useEffect(() => {
        if (chatHistoryData.length > 0 && !actionClick) {
            scrollToBottom();
        }
    }, [actionClick])

    // const reEngageFn = () => {
    //     let valid = reEngageValidFn()
    //     // console.log("valid=========1", valid)
    //     // console.log("valid=========2", props.allReadyChooseTemplate)
    //     // console.log("valid=========3", Object.keys(props.chooseTemplateData).length)
    //     if (valid) {
    //         if (props.allReadyChooseTemplate && Object.keys(props.chooseTemplateData).length > 0) {
    //             setReEngageModalFlag(true);
    //         } else {
    //             resetCardView();
    //             templateCardDesignList();
    //             setReEngageModalFlag(true);
    //         }
    //     }
    // }

    // const reEngageValidFn = () => {
    //     let valid = true
    //     if (activeTab === 'singleUser') {
    //         let phoneValidate = HomeUtility.validate_Phone_Number_without_plus(phoneNumber);
    //         if (!phoneValidate) {
    //             valid = false;
    //             Utility.toastNotifications("Please enter contact number", "Warning", 'warning')
    //         }
    //     } else if (activeTab === 'userGroup') {
    //         if (selectedGroupContact.length == 0) {
    //             valid = false;
    //             Utility.toastNotifications("Please select group", "Warning", 'warning')
    //         }
    //     }


    //     return valid;
    // }

    useEffect(() => {
        if (reEngageModalFlag) {
            findLabelByValue(props.localTimeZoneName)
            // alltemplateList();
            getCustomFieldListFn();
        }
    }, [reEngageModalFlag])

    const alltemplateList = (callFrom = "") => {
        let promise = new Promise((resolve, reject) => {
            const { userCredentials } = props;
            const { loaderStateTrue, loaderStateFalse, } = props;
            let filter = {}
            let _hash = {}
            if (userCredentials.user_details.user_type != 'app_admin') {
                _hash['org_id'] = userCredentials.user_details.org_id;
            }
            _hash['template_status'] = "APPROVED";
            _hash['list_type'] = "name_only";
            filter['filters'] = JSON.stringify(_hash);

            loaderStateTrue();
            alltemplateLists(filter, "listForReEngage").then((response) => {
                if (response.success) {
                    if (response.hasOwnProperty('data') && response.data.length > 0) {

                        const updatedObjects = response.data.map(obj => ({
                            ...obj,
                            ['label']: obj.hasOwnProperty('template_display_name') && obj.template_display_name ? obj.template_display_name : "",
                            ['value']: obj.template_id
                        }));
                        setTemplateListData(updatedObjects)
                    } else {
                        setTemplateListData([])
                    }
                    resolve(true)
                }
                loaderStateFalse();
            }).catch((error) => {
                console.error("************error*************", error)
                if (error) {
                }
                loaderStateFalse();
                if (error.message == "Network Error") {
                }
            });
        });
        return promise;
    }

    const findLabelByValue = (value) => {
        const zones = momentTimezone.tz.names();
        const options = zones.map(zone => ({
            label: `(GMT${momentTimezone.tz(zone).format('Z')}) ${zone.replace(/_/g, ' ')}`,
            value: zone
        }));
        const selectedOption = options.find(option => option.value == value);
        setSelectedTimezoneType({ label: selectedOption.label, value: selectedOption.value })
    };

    const getCustomFieldListFn = () => {
        const { userCredentials } = props;
        const { loaderStateTrue, loaderStateFalse, } = props;
        loaderStateTrue();
        let filters = {};
        const promise = new Promise((resolve, reject) => {
            customFieldListGet(filters).then((response) => {
                if (response.success && response.data.length > 0) {
                    let fieldTypeListArray = [];
                    response.data.map((e) => {
                        let fieldTypeListObj = {};
                        fieldTypeListObj['value'] = `{{${e.value}}}`;
                        fieldTypeListObj['label'] = e.label;
                        fieldTypeListArray.push(fieldTypeListObj)

                    })
                    setFieldTypeList(fieldTypeListArray);
                }
                loaderStateFalse();
            }).catch((error) => {
                console.error("************error*************", error)
                if (error) {
                }
                loaderStateFalse();
                if (error.message == "Network Error") {
                }
            });
        })
        return promise;
    }

    const fileUploadFN = () => {
        setfileUploadFNFlag(fileUploadFNFlag => !fileUploadFNFlag);

    }

    const chatHistoryInputFn = (e) => {
        setChatHistoryInput(e.target.value);
    }

    const chatHistorySendButttonFn = () => {
        if (chatHistoryInput.trim() != "") {
            let data = {};
            // let doc_obj = {};
            data["chat_text"] = chatHistoryInput;
            data["phone_number"] = chatModeSection ? chatModeParamsData.phone_number : paramsData.phone_number;
            data["profile_name"] = chatModeSection ? chatModeParamsData.profile_name : paramsData.profile_name;
            data['followup_by'] = props.userCredentials.id;
            if (chatHistoryDocumentObject.length > 0) {
                data["doc_obj"] = chatHistoryDocumentObject.length > 0 ? chatHistoryDocumentObject[0] : {};
            }
            props.loaderStateTrue();

            followUpPost(data).then((response) => {
                if (response.success) {
                    Utility.toastNotifications(response.message, "Success", "success")
                    setChatHistoryDocumentObject([]);
                    setChatHistoryInput("");
                    setfileUploadFNFlag(false);
                    let newchatData = [response["data"]];
                    // console.log('newchatData----->', newchatData)
                    if (newchatData.length > 0) {
                        newchatData[0]['contextMenu'] = {
                            visible: false,
                            x: 0,
                            y: 0
                        }
                    }
                    EventEmitter.emit("sendMessage", response["data"])
                    setChatHistoryData(prevRes => [...prevRes, ...newchatData]);
                    //chatHistoryGetApiCall();
                    if (response.data.hasOwnProperty('wa_id') && response.data.wa_id) {
                        props.setChatDocView([...props.chatDocViewId, response.data.wa_id])
                    }
                } else {
                    Utility.toastNotifications(response.message || "Something went wrong !", "Error", "error");
                    setChatHistoryInput("");
                    params.failCallback();
                }
                props.loaderStateFalse();
            }).catch((error) => {
                props.loaderStateFalse();
            });
        }

        if (chatHistoryInput.trim() == "") {
            Utility.toastNotifications("Please add text messages", "Warning", "warning")
        }

    }

    const emojiSelect = (emoji) => {
        if (emojiInputType == "chatHistoryMessage") {
            setChatHistoryInput(prevState => prevState + emoji.native);
        }
        if (emojiInputType == "schedulePannelMessage") {
            setFollowUpChatInput(prevState => prevState + emoji.native);
        }
    }

    const emojiShowContentFn = (type) => {
        if (type == "chatHistoryMessage") {
            setEmojiShowFlag(true);
            setEmojiInputType('chatHistoryMessage')
        }
        if (type == "schedulePannelMessage") {
            setEmojiShowFlag(true);
            setEmojiInputType('schedulePannelMessage')
        }
    }

    const closeEmojiContentFn = () => {
        setEmojiShowFlag(false);
        setEmojiInputType('')
    }

    const chatHistoryDropDocumentFileChange = (files, event) => {
        if (files.length == 1) {
            let fileName = files[0].name.split(".")
            let extension = fileName.pop()
            if (extension.toLowerCase() == "pdf" || extension.toLowerCase() == "PDF" || extension.toLowerCase() == "png" || extension.toLowerCase() == "PNG" || extension.toLowerCase() == "jpg" || extension.toLowerCase() == "JPG" || extension.toLowerCase() == "jpeg" || extension.toLowerCase() == "JPEG" || extension.toLowerCase() == "csv" || extension.toLowerCase() == "CSV" || extension.toLowerCase() == "doc" || extension.toLowerCase() == "DOC" || extension.toLowerCase() == "docx" || extension.toLowerCase() == "DOCX") {
                const fsize = files[0].size;
                const file = Math.round((fsize / 1024));
                if (file >= 2048) {
                    Utility.toastNotifications("File is too Big, please select a file less than 2mb", "Warning", "warning");
                } else {
                    getBase64(files[0], (result) => {
                        let _hash = {}
                        _hash['file_name'] = files[0].name
                        _hash['file_obj'] = result
                        setChatHistoryDocumentObject([_hash])
                    })
                }
            } else {
                Utility.toastNotifications("File format is not supported, it should be in pdf or png or jpg or csv or doc format", "Warning", "warning");
            }
        } else {
            setChatHistoryDocumentObjName("Choose file")
        }
        setFileInputKey(Date.now())
    }

    const chatHistoryUploadMultiDocumentFile = (event) => {
        if (event.target.files.length == 1) {
            let fileName = event.target.files[0].name.split(".")
            let extension = fileName.pop()
            if (extension.toLowerCase() == "pdf" || extension.toLowerCase() == "PDF" || extension.toLowerCase() == "png" || extension.toLowerCase() == "PNG" || extension.toLowerCase() == "jpg" || extension.toLowerCase() == "JPG" || extension.toLowerCase() == "jpeg" || extension.toLowerCase() == "JPEG" || extension.toLowerCase() == "csv" || extension.toLowerCase() == "CSV" || extension.toLowerCase() == "doc" || extension.toLowerCase() == "DOC" || extension.toLowerCase() == "docx" || extension.toLowerCase() == "DOCX") {
                const fsize = event.target.files[0].size;
                const file = Math.round((fsize / 1024));
                if (file >= 2048) {
                    Utility.toastNotifications("File is too Big, please select a file less than 2mb", "Warning", "warning");
                } else {
                    getBase64(event.target.files[0], (result) => {
                        let _hash = {}
                        _hash['file_name'] = event.target.files[0].name
                        _hash['file_obj'] = result
                        setChatHistoryDocumentObject([_hash])
                    })
                }
            } else {
                Utility.toastNotifications("File format is not supported, it should be in pdf or png or jpg or csv or doc format", "Warning", "warning");
            }
        } else {
            setChatHistoryDocumentObjName("Choose file")
        }
        setFileInputKey(Date.now())
    }

    const chatHistoryRemoveDoc = (i) => {
        let chatHistoryDocumentObjectArryTemp = chatHistoryDocumentObject.slice();
        chatHistoryDocumentObjectArryTemp.splice(i, 1);
        setChatHistoryDocumentObject(chatHistoryDocumentObjectArryTemp)
    }

    const getBase64 = (file, cb) => {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            cb(reader.result)
        };
        reader.onerror = function (error) {
        };
    }

    const deleteAndBefore = (phoneNumber, countryCode = 'in') => {
        var escapedCountryCode = countryCode ? countryCode.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') : '';
        var regex = new RegExp("^" + escapedCountryCode);
        return phoneNumber.replace(regex, "");
    }



    // const handelChangePhoneNumber = (e, countryCode = {}) => {
    //     setCurrentPage(1)
    //     setChatHistoryData([])
    //     setReander(false)
    //     if (e.trim() !== "") {
    //         let modifiedString = deleteAndBefore(e, countryCode.dialCode);
    //         let countryCodeValue = countryCode.countryCode.toUpperCase();
    //         const phoneNumberTemp = parsePhoneNumber(modifiedString, countryCodeValue);
    //         setPhoneNumberCountryCode(countryCode.countryCode)
    //         setPhoneNumberDialCode(countryCode.dialCode)
    //         if (phoneNumberTemp && phoneNumberTemp.isValid()) {
    //             setPhoneNumber(e)
    //             setPhoneNumberError("")
    //         } else {
    //             setPhoneNumber(e)
    //             setParamsData({})
    //             setTwentyfourshoursover(false);
    //             setChatHistoryInput("")
    //             setPhoneNumberError("Enter valid phone number")
    //             // Utility.toastNotifications("Enter valid phone number", "Warning", "warning")
    //         }
    //         if (e.length > 3) {
    //             const { loaderStateTrue, loaderStateFalse } = props;
    //             loaderStateTrue();
    //             let filters = {};
    //             let filter_op = {};
    //             let globalQueryParamshash = {};
    //             if (props.searchValue != "") {
    //                 globalQueryParamshash['search_attr'] = e
    //                 filter_op = Object.assign(filter_op, { "search_attr": "substring" });
    //             }
    //             if (Object.keys(filter_op).length > 0) {
    //                 filters["filter_op"] = JSON.stringify(filter_op);
    //             }
    //             filters['filters'] = JSON.stringify(globalQueryParamshash)

    //             ContactsList(filters, "get").then((response) => {
    //                 loaderStateFalse();
    //                 if (response.success) {
    //                     let contactArr = []
    //                     if (response.data.length > 0) {
    //                         response.data.map((val, idx) => {
    //                             let _hash = {}
    //                             _hash['label'] = val.name && val.name != "" ? `${val.phone_number} ( ${val.name} )` : `${val.phone_number}`
    //                             _hash['value'] = val.phone_number

    //                             contactArr.push(_hash);
    //                         })
    //                         setadditionalContactsOptions(contactArr)
    //                     } else {
    //                     }
    //                 } else {
    //                     Utility.toastNotifications("Something went wrong !", "Error", "error")
    //                 }
    //                 loaderStateFalse();
    //             }).catch((error) => {
    //                 loaderStateFalse();
    //             });
    //         }
    //     } else {
    //         setPhoneNumber("");
    //         setPhoneNumberError("Required field");
    //         Utility.toastNotifications("Required field", "Warning", "warning")
    //     }
    // }

    const closeReEngageModal = () => {
        setHasMoreMobileTemplateList(false)
        setPageRefresh(false)
        setMobileTemplateListData([]);
        setNoRecordFoundMsg('')
        setSelectedTabTemplate("broadcast_template");
        setTemplateListData([]);
        setSelectedDateTimeForReEngage('');
        setSelectedTemplateData([]);
        setMediaUrlError("");
        setDynamicUrlError("")
        setMediaUrl("");
        setSelectedTimezoneDataError("")
        setSelectedTimezoneType({ label: "Select Timezone", value: "selecttimezone" })
        setMessagesViewClickStatus(false)
        setTemplateName("")
        setCardTemplateOffsets(0)
        setCardTemplateLimits(10)
        setReEngageModalFlag(false);
        setSelectedView('card_view');
    }

    const confirmationForReEngageFn = () => {
        let vaildData = validReEngageFormData();
        if (vaildData) {
            setConfirmationForReEngageModalFlag(true);
        }
    }

    const isValidUrl = (url) => {
        const urlRegex = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;
        return urlRegex.test(url);
    };

    const validReEngageFormData = () => {
        let valid = true;
        let currentDate = new Date();
        if (selectedDateTimeForReEngage != "" && selectedDateTimeForReEngage <= currentDate) {
            valid = false;
            Utility.toastNotifications("Please select future date and time", "Warning", "warning");
        }
        if (selectedTimezoneType.value == "selecttimezone") {
            valid = false;
            setSelectedTimezoneDataError('Required Field')
        }

        if (mediaUrl != "") {
            if (!isValidUrl(mediaUrl)) {
                valid = false;
                setMediaUrlError("Enter valid url");
            } else {
                setMediaUrlError("");
            }
        }

        if (selectedTemplateData.length == 0) {
            valid = false;
            setSelectedTemplateDataError('Required Field')
        }

        if (selectedTemplateData.length > 0) {
            if (JSON.parse(selectedTemplateData[0].template_meta).components.length > 0) {
                let tempButtons = JSON.parse(selectedTemplateData[0].template_meta).components
                    .filter(f => f.type == "BUTTONS")
                if (tempButtons.length > 0) {
                    tempButtons[0].buttons.map((val, idx) => {
                        if (tempButtons[0].buttons[idx].type == "URL")
                            // if (tempButtons.length > 0 && tempButtons[0].buttons[0].type == "URL") {
                            if (val.hasOwnProperty("example") && val.example.length > 0) {
                                let URLbuttons = val.example[0];
                                if (URLbuttons == "") {
                                    valid = false;
                                    setDynamicUrlError("Required Field");
                                } else {
                                    setDynamicUrlError("");
                                }
                            }

                    })
                }
            }
        }

        if (selectedTemplateData.length > 0) {
            if (selectedTemplateData[0].template_meta && JSON.parse(selectedTemplateData[0].template_meta) && JSON.parse(selectedTemplateData[0].template_meta).components && JSON.parse(selectedTemplateData[0].template_meta).components.length > 0 && JSON.parse(selectedTemplateData[0].template_meta).components[0].format && JSON.parse(selectedTemplateData[0].template_meta).components[0].format == "IMAGE") {
                if (mediaUrl == "") {
                    valid = false;
                    setMediaUrlError("Required Field");
                }

            }
        }
        if (selectedTemplateData.length > 0) {
            if (selectedTemplateData[0].template_meta && JSON.parse(selectedTemplateData[0].template_meta) && JSON.parse(selectedTemplateData[0].template_meta).components && JSON.parse(selectedTemplateData[0].template_meta).components.length > 0 && JSON.parse(selectedTemplateData[0].template_meta).components[0].format && JSON.parse(selectedTemplateData[0].template_meta).components[0].format == "DOCUMENT") {
                if (mediaUrl == "") {
                    valid = false;
                    setMediaUrlError("Required Field");
                }

            }
        }
        return valid;
    }

    const zoominFunction = () => {
        let zoominzoomoutflag = "zoominzoomoutclass"
        setZoominzoomoutflag(zoominzoomoutflag)
    }
    const zoomoutFunction = () => {
        let zoominzoomoutflag = ""
        setZoominzoomoutflag(zoominzoomoutflag)
    }

    const handelChangeTimeZone = (e) => {
        setSelectedDateTime('');
        setSelectedTimezoneDataError("")
        setSelectedTimezoneType({ label: e.label, value: e.value })
    }

    const deleteSelectedDateTimeFn = () => {
        setSelectedDateTimeForReEngage('');
    }

    const handleSelectedDateTimeFnForReEngage = (e, type) => {
        const currentDate = new Date();
        if (type == 'Schedule_Date_Time') {
            if (e <= currentDate) {
                Utility.toastNotifications("Selected date time will be future date time", "Warming", "warning");
                setSelectedDateTimeForReEngage('');
            } else {
                setSelectedDateTimeForReEngage(e);
            }
        }
    }

    const handleChangeChooseTemplateFn = (event) => {
        const { loaderStateTrue, loaderStateFalse } = props;
        loaderStateTrue();
        ondemandTemplateLists(event.id).then((response) => {
            // console.log("response========", response)
            if (response.success) {
                let resData = response.data[0];
                resData['label'] = response.data[0].template_name
                resData['value'] = response.data[0].template_id
                let isDynamicUrl = JSON.parse(resData.template_custom_data).quick_reply.filter(f => f.hasOwnProperty("url_type") && f.url_type.value == "dynamic")
                if (isDynamicUrl.length > 0) {
                    setPreValueDynamicUrl(JSON.parse(resData.template_custom_data).quick_reply[0].urlInputValues)
                }
                if (resData) {
                    setSelectedTemplateData([resData]);
                    setSelectedTemplateDataError("");
                    setSelectedTimezoneDataError("");
                    setMediaUrl("");
                    setpreviousVal([]);
                    setpreviousValUrl([]);
                    setisPreviousVal(false);
                    setisPreviousValUrl(false);
                    setDynamicUrlError("");
                } else {
                    setSelectedTemplateData([])
                }
            }
            loaderStateFalse();
        }).catch((error) => {
            console.error("************error*************", error)
            if (error) {
                //Utility.toastNotifications(error.message, "Error", "error");
            }
            loaderStateFalse();
            if (error.message == "Network Error") {
            }
        });
    }

    const handleChangeDynamicHeader = (e, headerId, headerValue) => {
        let updatedTemplateData = [...selectedTemplateData];
        let template_custom_data = JSON.parse(updatedTemplateData[0].template_custom_data);
        let headerInputValuesTemp = { ...template_custom_data?.headerInputValues };

        let template_meta_data = JSON.parse(updatedTemplateData[0].template_meta);
        let template_meta_data_components = template_meta_data?.components;
        let headerComponent = template_meta_data_components.find(component => component.type === "HEADER");
        if (headerComponent != undefined) {
            if (headerComponent.hasOwnProperty('example')) {
                let dynamicHeaderTextArray = headerComponent.example.header_text.slice();
                if (e !== "") {
                    headerInputValuesTemp = {
                        ...headerInputValuesTemp,
                        [headerValue]: e.value
                    };
                    dynamicHeaderTextArray[headerId] = e.value;
                } else {
                    headerInputValuesTemp = {
                        ...headerInputValuesTemp,
                        [headerValue]: ""
                    };
                    dynamicHeaderTextArray[headerId] = "";
                }
                headerComponent = {
                    ...headerComponent,
                    example: {
                        ...headerComponent.example,
                        header_text: dynamicHeaderTextArray
                    }
                };
                let index = template_meta_data_components.findIndex(component => component.type === "HEADER");
                template_meta_data_components[index] = headerComponent;
                template_custom_data.headerInputValues = headerInputValuesTemp;
                updatedTemplateData[0].template_custom_data = JSON.stringify(template_custom_data);
                updatedTemplateData[0].template_meta = JSON.stringify(template_meta_data);
                setSelectedTemplateData(updatedTemplateData);
            }
        }
    };

    const handleOnInputChangeDynamicHeaderFn = (e, headerId, headerValue) => {
        let updatedTemplateData = [...selectedTemplateData];
        let template_custom_data = JSON.parse(updatedTemplateData[0].template_custom_data);
        let headerInputValuesTemp = { ...template_custom_data?.headerInputValues };

        let template_meta_data = JSON.parse(updatedTemplateData[0].template_meta);
        let template_meta_data_components = template_meta_data?.components;
        let headerComponent = template_meta_data_components.find(component => component.type === "HEADER");
        if (headerComponent != undefined) {
            if (headerComponent.hasOwnProperty('example')) {
                let dynamicHeaderTextArray = headerComponent.example.header_text.slice();
                if (e.target.value !== "") {
                    headerInputValuesTemp = {
                        ...headerInputValuesTemp,
                        [headerValue]: e.target.value
                    };
                    dynamicHeaderTextArray[headerId] = e.target.value;
                } else {
                }
                headerComponent = {
                    ...headerComponent,
                    example: {
                        ...headerComponent.example,
                        header_text: dynamicHeaderTextArray
                    }
                };
                let index = template_meta_data_components.findIndex(component => component.type === "HEADER");
                template_meta_data_components[index] = headerComponent;
                template_custom_data.headerInputValues = headerInputValuesTemp;
                updatedTemplateData[0].template_custom_data = JSON.stringify(template_custom_data);
                updatedTemplateData[0].template_meta = JSON.stringify(template_meta_data);
                setSelectedTemplateData(updatedTemplateData);
            }
        }
    }

    const backToPreviousValBody = (e, bodyId, bodyValue) => {
        let updatedTemplateData = [...selectedTemplateData];
        let template_custom_data = JSON.parse(updatedTemplateData[0].template_custom_data);
        let bodyInputValuesTemp = { ...template_custom_data?.bodyInputValues };
        let template_meta_data = JSON.parse(updatedTemplateData[0].template_meta);

        bodyInputValuesTemp = {
            ...bodyInputValuesTemp,
            [bodyValue]: previousVal[bodyId][bodyValue]
        };

        template_custom_data.bodyInputValues = bodyInputValuesTemp;
        updatedTemplateData[0].template_custom_data = JSON.stringify(template_custom_data);
        updatedTemplateData[0].template_meta = JSON.stringify(template_meta_data);
        setSelectedTemplateData(updatedTemplateData);
    }

    const backToPreviousValUrl = (e, bodyId, bodyValue) => {
        let updatedTemplateData = [...selectedTemplateData];
        let template_custom_data = JSON.parse(updatedTemplateData[0].template_custom_data);
        let template_meta_data = JSON.parse(updatedTemplateData[0].template_meta);
        let template_meta_data_components = template_meta_data?.components;
        let urlInputValuesTemp = { ...template_custom_data?.quick_reply[0]?.urlInputValues };
        let urlComponent = template_meta_data_components.find(component => component.type === "BUTTONS");
        let urlComponentButton = urlComponent.buttons.find(component => component.type === "URL");

        if (urlComponentButton) {
            urlInputValuesTemp[Object.keys(urlInputValuesTemp).map((val) => val)] = previousValUrl[bodyId][bodyValue];
            template_custom_data.quick_reply[0].urlInputValues = urlInputValuesTemp;
            for (let i = 0; i < template_meta_data.components.length; i++) {
                const currentItem = template_meta_data.components[i];
                if (currentItem.hasOwnProperty("buttons")) {
                    currentItem.buttons[0].example = []
                    currentItem.buttons[0].example.push(previousValUrl[bodyId][bodyValue])
                }
            }
            updatedTemplateData[0].template_custom_data = JSON.stringify(template_custom_data);
            updatedTemplateData[0].template_meta = JSON.stringify(template_meta_data);
            setSelectedTemplateData(updatedTemplateData);
        }
    }

    const handleChangeDynamicBody = (e, bodyId, bodyValue) => {
        let updatedTemplateData = [...selectedTemplateData];
        let template_custom_data = JSON.parse(updatedTemplateData[0].template_custom_data);
        let bodyInputValuesTemp = { ...template_custom_data?.bodyInputValues };

        let template_meta_data = JSON.parse(updatedTemplateData[0].template_meta);
        let template_meta_data_components = template_meta_data?.components;
        let bodyComponent = template_meta_data_components.find(component => component.type === "BODY");
        if (bodyComponent != undefined) {
            if (bodyComponent.hasOwnProperty('example')) {
                let dynamicBodyTextArray = bodyComponent.example.body_text.slice();
                if (e !== "") {
                    bodyInputValuesTemp = {
                        ...bodyInputValuesTemp,
                        [bodyValue]: e.value
                    };
                    dynamicBodyTextArray[0][bodyId] = e.value;
                    if (isPreviousVal == false) {
                        Object.keys(template_custom_data.bodyInputValues).forEach(key => {
                            let tempHash = {}
                            tempHash[key] = template_custom_data.bodyInputValues[key];
                            previousVal.push(tempHash)
                        })
                        // setpreviousVal({ [bodyValue]: template_custom_data.bodyInputValues[bodyValue] })
                        setisPreviousVal(true)
                    }
                } else {
                    bodyInputValuesTemp = {
                        ...bodyInputValuesTemp,
                        [bodyValue]: ""
                    };
                    dynamicBodyTextArray[0][bodyId] = "";
                }
                bodyComponent = {
                    ...bodyComponent,
                    example: {
                        ...bodyComponent.example,
                        body_text: dynamicBodyTextArray
                    }
                };
                let index = template_meta_data_components.findIndex(component => component.type === "BODY");
                template_meta_data_components[index] = bodyComponent;
                template_custom_data.bodyInputValues = bodyInputValuesTemp;
                updatedTemplateData[0].template_custom_data = JSON.stringify(template_custom_data);
                updatedTemplateData[0].template_meta = JSON.stringify(template_meta_data);
                setSelectedTemplateData(updatedTemplateData);
            }
        }
    };

    const handleOnInputChangeDynamicBodyFn = (e, bodyId, bodyValue) => {
        const { fbMessageTemplateBodyCharactersLimit, fbMessageTemplateVariableCharactersLimit } = Config;
        let updatedTemplateData = [...selectedTemplateData];
        let template_custom_data = JSON.parse(updatedTemplateData[0].template_custom_data);
        let bodyInputValuesTemp = { ...template_custom_data?.bodyInputValues };

        let template_meta_data = JSON.parse(updatedTemplateData[0].template_meta);
        let template_meta_data_components = template_meta_data?.components;
        let bodyComponent = template_meta_data_components.find(component => component.type === "BODY");
        if (bodyComponent != undefined) {
            if (bodyComponent.hasOwnProperty('example')) {
                let dynamicBodyTextArray = bodyComponent.example.body_text.slice();
                if (e.target.value !== "") {
                    bodyInputValuesTemp = {
                        ...bodyInputValuesTemp,
                        [bodyValue]: e.target.value.slice(0, 1024)
                        // [bodyValue]: e.target.value.slice(0, fbMessageTemplateVariableCharactersLimit)
                    };
                    dynamicBodyTextArray[0][bodyId] = e.target.value.slice(0, 1024);
                    // dynamicBodyTextArray[0][bodyId] = e.target.value.slice(0, fbMessageTemplateVariableCharactersLimit);
                    if (isPreviousVal == false) {
                        Object.keys(template_custom_data.bodyInputValues).forEach(key => {
                            let tempHash = {}
                            tempHash[key] = template_custom_data.bodyInputValues[key];
                            previousVal.push(tempHash)
                        })
                        setisPreviousVal(true)
                    }
                } else {
                }
                bodyComponent = {
                    ...bodyComponent,
                    example: {
                        ...bodyComponent.example,
                        body_text: dynamicBodyTextArray
                    }

                };
                let index = template_meta_data_components.findIndex(component => component.type === "BODY");
                template_meta_data_components[index] = bodyComponent;
                template_custom_data.bodyInputValues = bodyInputValuesTemp;
                updatedTemplateData[0].template_custom_data = JSON.stringify(template_custom_data);
                updatedTemplateData[0].template_meta = JSON.stringify(template_meta_data);
                setSelectedTemplateData(updatedTemplateData);
            }
        }
    };

    const handleChangeDynamicUrl = (e, urlId) => {
        const { name, value } = e.target;
        let updatedTemplateData = [...selectedTemplateData];
        let template_custom_data = JSON.parse(updatedTemplateData[0].template_custom_data);
        let template_meta_data = JSON.parse(updatedTemplateData[0].template_meta);
        let urlInputValuesTemp = { ...template_custom_data?.quick_reply[0]?.urlInputValues };
        let template_meta_data_components = template_meta_data?.components;
        let urlComponent = template_meta_data_components.find(component => component.type === "BUTTONS");
        if (urlComponent) {
            let urlComponentButton = urlComponent.buttons.find(component => component.type === "URL");
            if (urlComponentButton) {
                let dynamicUrlTextArray = [...urlComponentButton.example];
                urlInputValuesTemp[name] = value;
                dynamicUrlTextArray[urlId] = value;
                urlComponentButton.example = dynamicUrlTextArray;
                urlComponent.buttons = [urlComponentButton];
                let index = template_meta_data_components.findIndex(component => component.type === "BUTTONS");
                let buttonTextToMatch = template_meta_data_components.find(component => component.type === "BUTTONS").buttons[0].text;
                let urlIndex = template_custom_data.quick_reply.findIndex(reply => reply.button_text === buttonTextToMatch);
                template_meta_data_components[index] = urlComponent;
                template_custom_data.quick_reply[urlIndex].urlInputValues = urlInputValuesTemp;
                updatedTemplateData[0].template_custom_data = JSON.stringify(template_custom_data);
                updatedTemplateData[0].template_meta = JSON.stringify(template_meta_data);
                setSelectedTemplateData(updatedTemplateData);
            }
            if (isPreviousValUrl == false) {
                previousValUrl.push(preValueDynamicUrl)
                setisPreviousValUrl(true)
            }
        }
    };

    const handleChangeMediaUrl = (event, type, callingForChooseUrl = false) => {
        if (type == "media") {
            if (callingForChooseUrl) {
                setMediaUrl(event);
                setMediaUrlError('');
            } else {
                if (event.target.value != "") {
                    setMediaUrl(event.target.value);
                    setMediaUrlError('');
                } else {
                    setMediaUrl("");
                }
            }
        }

    }


    const confirmationForReEngageModalHide = () => {
        setConfirmationForReEngageModalFlag(false);
    }

    const confirmationForReEngageCancleButton = () => {
        setConfirmationForReEngageModalFlag(false);
    }

    const confirmationForReEngageConfirmButton = () => {
        setConfirmationForReEngageModalFlag(false);
        reEngageSaveFn()
        getUserDataFromPhoneNumberApiFn()
        setEnableFlag(false)
    }

    const formatingReEngageDataset = () => {
        let dataset = [];
        let hash = {}
        let facebooktemplateDataset = WhatsAppDataFormate.campaignBroadcastingTemplateDatasetFormatting(selectedTemplateData, mediaUrl);

        hash['cron_exp'] = "";
        hash['recurring'] = false;

        if (Object.keys(paramsData).length > 0) {
            hash['campaign_name'] = `Re engage-${selectedUserData.phone_number}`;
            hash['phone_number'] = [selectedUserData.phone_number];
        } else {
            hash['phone_number'] = [phoneNumber];
            hash['campaign_name'] = `Re engage-${phoneNumber}`;
        }

        if (selectedTimezoneType.value != "selecttimezone") {
            hash['schedule_timezone'] = selectedTimezoneType.value;
        }
        if (selectedDateTimeForReEngage != "") {
            let datePickerTimeString = moment(selectedDateTimeForReEngage).format('YYYY-MM-DD HH:mm:ss');
            let selectedTimezone = selectedTimezoneType.value;
            var selectedDateTimeObj = moment.tz(datePickerTimeString, 'YYYY-MM-DD HH:mm:ss', selectedTimezone);
            var istDateTime = selectedDateTimeObj.clone().tz("Asia/Kolkata");
            var istdate = istDateTime.format('YYYY-MM-DD HH:mm:ss');
            hash['schedule_date'] = istdate
            hash['schedule_date_raw'] = datePickerTimeString
        } else {
            hash['schedule_date_raw'] = moment().tz(selectedTimezoneType.value).format('YYYY-MM-DD HH:mm:ss');
            hash['schedule_date'] = moment().tz(selectedTimezoneType.value).clone().tz("Asia/Kolkata").format('YYYY-MM-DD HH:mm:ss');
        }
        hash['message'] = JSON.stringify({
            "template": facebooktemplateDataset,
            "messaging_product": "whatsapp",
            "recipient_type": "individual",
            "type": "template"
        });
        let selectedTemplateObject = selectedTemplateData[0];
        selectedTemplateObject['media_url'] = mediaUrl;
        hash['fb_template_message'] = JSON.stringify(selectedTemplateObject);
        dataset.push(hash)
        return dataset;
    }


    const reEngageSaveFn = () => {
        const { loaderStateTrue, loaderStateFalse } = props;
        let dataset = formatingReEngageDataset();
        loaderStateTrue();
        let type = "";
        let id = "";
        type = "post"
        campaignBroadcastingPost(dataset, type, id).then((response) => {
            loaderStateFalse();
            if (type = "post") {
                if (response.length > 0) {
                    response.map((data, index) => {
                        if (data.success) {
                            Utility.toastNotifications(data.message, "Success", "success");

                            if (checkedInboxMode) {
                                closeReEngageModal();
                                getLastToMessage(chatModeParamsData)
                            } else if (scheduleMessageModalFlag) {
                                closeReEngageModal();
                                getLastToMessage(scheduleMessageParamsData)
                            } else {
                                closeReEngageModal();
                                getLastToMessage(paramsData)
                                // chatHistoryModalClose();
                            }
                        }
                    })
                }
            }
        }).catch((error) => {
            console.error("************error*************", error)
            if (error) {
                //Utility.toastNotifications(error.message, "Error", "error");
            }
            loaderStateFalse();
            if (error.message == "Network Error") {

            }
        });
        //}
    }

    const handleChangeInboxMode = (nextChecked) => {
        localStorage.setItem('switchmode_' + props.value, nextChecked ? "1" : "0")
        setCheckedInboxMode(nextChecked);
        handleChangeLiveMode(nextChecked)
    };

    const handleChangeLiveMode = nextChecked => {
        const { loaderStateTrue, loaderStateFalse } = props;
        let current_timestamp = moment().format("YYYY-MM-DD HH:mm:ss")
        let dataset = {};
        dataset['last_requested_action_name'] = nextChecked ? 'agent_takeover' : 'agent_release';
        dataset['deactive_request_at'] = nextChecked ? current_timestamp : null;
        let phoneNumber = chatModeSection ? chatModeParamsData.phone_number : paramsData.phone_number;
        localStorage.setItem('livemode_' + props.value, nextChecked ? "1" : "0")
        loaderStateTrue();
        userInformationUpdate(dataset, phoneNumber).then((response) => {
            loaderStateFalse();
            if (response.success) {
                // Utility.toastNotifications(response.message, "Success", "success");
                loaderStateFalse();
                setIsLiveChat(nextChecked ? 1 : 0)
                setCheckedLiveMode(nextChecked);
            } else {
                Utility.toastNotifications(response.message, "Error", "error");
                loaderStateFalse();
            }

        }).catch((error) => {
            console.error("************error*************", error)
            if (error) {
                //Utility.toastNotifications(error.message, "Error", "error");
            }
            loaderStateFalse();
            if (error.message == "Network Error") {

            }
        });
    };

    useEffect(() => {
        if (props.callingFrom == "chathistoryMenu") {
            let data = {
                isToggle: true,
                value: isLiveChat
            }
            props.updateOnlyGridData(data);
        }
    }, [isLiveChat])

    const handelChangeMessageType = (e, type) => {
        if (type == "text_message") {
            setTemplateMessageType(type)
        } else {
            setTemplateMessageType(type)
            setReEngageModalFlag(true);
        }
    }

    const fileUploadPopupFN = () => {
        setUploadFilePopupFlag(true)
    }
    const closeUploadFilePopup = () => {
        setUploadFilePopupFlag(false)
        // setChatHistoryDocumentObject([])
    }

    useEffect(() => {
        if (props.selectedPhones && props.selectedPhones?.length > 0) {
            // console.log("props.selectedPhones=======>", props.selectedPhones)
            let phoneNumber = props.selectedPhones;
            let modifiedPhoneNumber = phoneNumber.map((item) => {
                return {
                    label: item,
                    value: item,
                    type: "contact"
                }
            })
            // setPhoneNumber(phoneNumber)
            setSelectedGroupContact(modifiedPhoneNumber)
            setActiveTab("userGroup")
        }
    }, [props.selectedPhones])

    useEffect(() => {
        if (selectedGroupContact.length > 0 && activeTab == "userGroup") {
            setTwentyfourshoursover(true);
        } else if (selectedGroupContact == 0 && activeTab == "csv") {
            setTwentyfourshoursover(true);
        } else {
            setTwentyfourshoursover(false);
        }
    }, [selectedGroupContact])

    const handleTabClick = (tab) => {
        setActiveTab(tab);
        setIsDropdownOpen(false);
        if (tab == 'userGroup') {
            setPhoneNumber('91')
            setChatModeParamsData({})
            setParamsData({})
            setChatHistoryData([])
            setTwentyfourshoursover(false);
        }
        if (tab == "csv") {
            setChatModeParamsData({})
            setParamsData({})
            setChatHistoryData([])
            setTwentyfourshoursover(true);
        }
        setSelectedGroupContact([])
        setGropuAndPhoneNumberList([])
        setSelectedUser({})
        setUploadFilePopupFlag(false)
        setChatHistoryDocumentObject([]);
        setChatHistoryInput("");
        setfileUploadFNFlag(false);
        let phone = props.userCredentials?.user_details?.whatsapp_business_phone_number;
        if (phone && phone.trim().length > 3) {
            const normalized = phone.startsWith("+") ? phone : "+" + phone;
            const parsed = parsePhoneNumberFromString(normalized);
            if (parsed && parsed.isValid()) {
                setPhoneNumber(parsed.countryCallingCode || '91')
                setPhoneNumberDialCode(parsed.countryCallingCode || '91');
                setSelectedCountryCode(parsed.country?.toLowerCase() || 'in');
            } else {
                setPhoneNumber('91')
                setPhoneNumberDialCode("91");
                setSelectedCountryCode("in");
            }
        }
    };

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen); // Toggle dropdown on arrow click
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        let phoneValidate = HomeUtility.validate_Phone_Number_without_plus(phoneNumber);
        // console.log("phoneNumber update========phoneValidate", phoneValidate, phoneNumber)

        if (phoneValidate) {
            setChatHistoryData([])
            getUserDataFromPhoneNumberApiFn()
        }
        if (Utility.isCountryCodePhoneNumber(props?.paramsData?.phone_number) && !phoneValidate) {
            setChatHistoryData([])
            getUserDataFromPhoneNumberApiFn()
        }
        //console.log("phoneNumber update========", phoneNumber)
    }, [phoneNumber])


    const handleOnBlurChange = (e) => {
        if (e.target.value != "") {
            let phoneValidate = HomeUtility.validate_Phone_Number_without_plus(e.target.value);
            if (phoneValidate) {
                let newData = { "label": e.target.value, "value": e.target.value };
                setadditionalContactSelectedValue(prevData => [...prevData, newData]);
                setPhoneNumber(e.target.value)
            } else {
                Utility.toastNotifications("Please input valid phone number", "Error", "error")
            }
        }
    }

    const handleInputChangeAdditionalContact = (e) => {
        if (e.length > 2) {
            const { loaderStateTrue, loaderStateFalse } = props;
            loaderStateTrue();
            let filters = {};
            let filter_op = {};
            let globalQueryParamshash = {};
            if (props.searchValue != "") {
                globalQueryParamshash['search_attr'] = e
                filter_op = Object.assign(filter_op, { "search_attr": "substring" });
            }
            if (Object.keys(filter_op).length > 0) {
                filters["filter_op"] = JSON.stringify(filter_op);
            }
            filters['filters'] = JSON.stringify(globalQueryParamshash)

            ContactsList(filters, "get").then((response) => {
                loaderStateFalse();
                if (response.success) {
                    let contactArr = []
                    if (response.data.length > 0) {
                        response.data.map((val, idx) => {
                            let _hash = {}
                            _hash['label'] = val.name && val.name != "" ? `${val.phone_number} ( ${val.name} )` : `${val.phone_number}`
                            _hash['value'] = val.phone_number

                            contactArr.push(_hash);
                        })
                        setadditionalContactsOptions(contactArr)
                    } else {
                    }
                } else {
                    Utility.toastNotifications("Something went wrong !", "Error", "error")
                }
                loaderStateFalse();
            }).catch((error) => {
                loaderStateFalse();
            });
        }
    }

    const handleChangeAdditionalContact = (e) => {
        if (e) {
            setadditionalContactSelectedValue(e)
            setPhoneNumber(e.value)
        } else {
            setadditionalContactSelectedValue([])
        }
    }

    const handleChangeGroupContactFn = (event) => {
        if (event) {
            setSelectedGroupContact(event)
        } else {
            setSelectedGroupContact([])
        }
    }

    useEffect(() => {
        if (activeTab === 'userGroup') {
            // allGroupContactList();
        }
    }, [activeTab])

    const allGroupContactList = (callFrom = "") => {
        let promise = new Promise((resolve, reject) => {
            const { userCredentials } = props;
            const { loaderStateTrue, loaderStateFalse, } = props;
            let filter = {}
            let _hash = {}
            if (userCredentials.user_details.user_type != 'app_admin') {
                _hash['org_id'] = userCredentials.user_details.org_id;
            }
            filter['filters'] = JSON.stringify(_hash);

            loaderStateTrue();
            allgroupContactLists().then((response) => {
                if (response.success) {
                    let groupContactListArry = [];
                    response.data.map((tempItem) => {
                        if (tempItem?.members && tempItem?.members.length > 0) {
                            let groupContactListHash = {};
                            groupContactListHash['label'] = `${tempItem.name} (contacts: ${tempItem.members_count})`;
                            groupContactListHash['value'] = tempItem.id;
                            groupContactListArry.push(groupContactListHash);
                        }
                    })
                    setGroupContactsData(groupContactListArry)
                    if (callFrom == "fromEdit") {
                        setBulkMessageEditFlag(true)
                    }
                    resolve(true)

                }
                loaderStateFalse();
            }).catch((error) => {
                console.error("************error*************", error)
                if (error) {
                }
                loaderStateFalse();
                if (error.message == "Network Error") {
                }
            });
        });
        return promise;
    }

    //Template message/mobile view
    const handleSelectTabChange = (tabName) => {
        // console.log("tabName=========", tabName)
        setSelectedTabTemplate(tabName);
        resetCardView();
    };



    const resetCardView = () => {
        setCardTemplateOffsets(0)
        setCardTemplateLimits(10)
        setMobileTemplateListData([]);
        setNoRecordFoundMsg('')
        setPageRefresh(true);
    }

    const handleUserSearchBar = (e) => {
        if (templateName.trim() != e.target.value.trim()) {
            if (e.target.value != "") {
                setTemplateName(e.target.value.trim())
            } else {
                setTemplateName("")
                setClearTemplateSearchDataStatus(true)
            }
        }
        if (e.target.value.trim() == '') {
            resetCardView()
        }
    }

    useEffect(() => {
        if (templateName.trim() != "") {
            resetCardView();
        }
    }, [templateName])

    useEffect(() => {
        if (clearTemplateSearchDataStatus) {
            resetCardView();
        }
    }, [clearTemplateSearchDataStatus])

    const clearSearchValue = () => {
        setTemplateName("")
        setCardTemplateOffsets(0)
        setCardTemplateLimits(10)
        setMobileTemplateListData([]);
        setNoRecordFoundMsg('')
        setClearTemplateSearchDataStatus(true)
    }

    useEffect(() => {
        if (pageRefresh) {
            templateCardDesignList();
        }
    }, [pageRefresh])


    const templateCardDesignList = async () => {
        const { loaderStateTrue, loaderStateFalse, } = props;
        try {
            loaderStateTrue();
            let filters = {};
            let globalQueryParamshash = {};
            if (templateName.trim() !== "") {
                if (selectedTabTemplate === "broadcast_template") {
                    globalQueryParamshash['template_display_name'] = templateName.trim();
                    filters['filter_op'] = JSON.stringify({ "template_display_name": "substring" });
                } else {
                    globalQueryParamshash['template_name'] = templateName.trim();
                    filters['filter_op'] = JSON.stringify({ "template_name": "substring" });
                }
            }

            globalQueryParamshash['org_id'] = props.userCredentials.user_details.org_id;

            if (selectedTabTemplate === "broadcast_template") {
                globalQueryParamshash['template_status'] = "APPROVED";
            } else {
                globalQueryParamshash['template_type'] = ['text', 'interactive', 'multimedia'];
            }

            globalQueryParamshash["offset"] = cardTemplateOffsets;
            globalQueryParamshash["limit"] = cardTemplateLimits;
            filters['filters'] = JSON.stringify(globalQueryParamshash);


            const response = await alltemplateLists(filters, selectedTabTemplate === "broadcast_template" ? "listForReEngage" : "interactive_template");
            if (response.success) {
                if (response.total > 0 || response.data.length > 0) {
                    setHasMoreMobileTemplateList(true);

                    if (cardTemplateOffsets <= response.total) {
                        setCardTemplateOffsets((prevOffset) => prevOffset + cardTemplateLimits);

                        setMobileTemplateListData((prevList) => [
                            ...prevList,
                            ...response.data
                        ]);
                    } else {
                        setHasMoreMobileTemplateList(false);
                    }

                    if (response.data.length === 0) {
                        setHasMoreMobileTemplateList(false);
                    }
                } else {
                    setMobileTemplateListData([]);
                    setNoRecordFoundMsg('No records found')
                    setHasMoreMobileTemplateList(false);
                }
                setPageRefresh(false);
                setClearTemplateSearchDataStatus(false)
            }
        } catch (error) {
            console.error("Error fetching template list", error);
            // Optional error handling, e.g., show toast notifications
            loaderStateFalse();
        } finally {
            setTimeout(() => {
                loaderStateFalse();
            }, 500);
        }
    };

    const getNextData = () => {
        // console.log('1111111111111111111111111111111111111111')
        templateCardDesignList();
    }
    useEffect(() => {
        // console.log("MobileTemplateListData==========", mobileTemplateListData)
    }, [mobileTemplateListData])

    const handleClickSuggestionContact = (suggestion) => {
        setSelectedUser(suggestion)
        setPhoneNumber(suggestion.value)
        if (suggestion.hasOwnProperty('last_chat_initiated_at') && suggestion.last_chat_initiated_at != "") {
            checkDateTimeHoursOverOrNot(suggestion.last_chat_initiated_at);
        }
        setadditionalContactsOptions([])
        setChatHistoryDocumentObject([]);
        setChatHistoryInput("");
        setfileUploadFNFlag(false);
    };

    const closeReengageModalCallBackFn = () => {
        setReEngageModalFlag(false);
        setTemplateListData([]);
        setSelectedDateTimeForReEngage('');
        setSelectedTemplateData([]);
        setMediaUrlError("");
        setDynamicUrlError("")
        setMediaUrl("");
        setSelectedTimezoneDataError("")
        setSelectedTimezoneType({ label: "Select Timezone", value: "selecttimezone" })
        setCardTemplateOffsets(0)
        setCardTemplateLimits(10)
        setMobileTemplateListData([]);
        setNoRecordFoundMsg('')
        setSelectedView('card_view');
    }


    const messageViewClickFunction = (status) => {
        if (status) {
            setMessagesViewClickStatus(true)
        } else {
            setMessagesViewClickStatus(false)
        }
    }


    const handelChangePhoneNumber = (e, countryCode = {}, callFrom = "") => {
        setUploadFilePopupFlag(false)
        setReander(false)
        if (callFrom == 'multiselect') {
            setSelectedUser({})
            setCurrentPage(1)
            setPhoneNumber('')
            setParamsData({})
            setChatHistoryData([])
            if (e) {
                if (e.length == 0) {
                    setGropuAndPhoneNumberList([])
                    setSelectedGroupContact([])
                } else {
                    setSelectedGroupContact(e)
                }
            } else {
                setSelectedGroupContact([])
            }
        }
        if (callFrom == 'typing') {
            if (e) {
                setSearchingData(e)
                if (e.length == 1) {
                    setGropuAndPhoneNumberList([])
                }
            }
        }

        if (callFrom == "single_phone") {
            setSelectedUser({})
            setChatHistoryData([])
            setCurrentPage(1)
            if (e.trim() !== "") {
                let modifiedString = deleteAndBefore(e, countryCode.dialCode);
                let countryCodeValue = countryCode.countryCode.toUpperCase();
                const phoneNumberTemp = parsePhoneNumber(modifiedString, countryCodeValue);
                setPhoneNumberCountryCode(countryCode.countryCode)
                setPhoneNumberDialCode(countryCode.dialCode)
                if (phoneNumberTemp && phoneNumberTemp.isValid()) {
                    setPhoneNumber(e)
                    setPhoneNumberError("")
                } else {
                    setPhoneNumber(e)
                    setParamsData({})
                    setTwentyfourshoursover(false);
                    setChatHistoryInput("")
                    setPhoneNumberError("Enter valid phone number")
                }
                if (e.length > 3) {
                    const { loaderStateTrue, loaderStateFalse } = props;
                    loaderStateTrue();
                    let filters = {};
                    let filter_op = {};
                    let globalQueryParamshash = {};
                    if (props.searchValue != "") {
                        globalQueryParamshash['search_attr'] = e
                        filter_op = Object.assign(filter_op, { "search_attr": "substring" });
                    }
                    if (Object.keys(filter_op).length > 0) {
                        filters["filter_op"] = JSON.stringify(filter_op);
                    }
                    filters['filters'] = JSON.stringify(globalQueryParamshash)

                    ContactsList(filters, "get").then((response) => {
                        loaderStateFalse();
                        if (response.success) {
                            let contactArr = []
                            if (response.data.length > 0) {
                                response.data.map((val, idx) => {
                                    let _hash = {}
                                    _hash['label'] = val.name && val.name != "" ? `${val.phone_number} ( ${val.name} )` : `${val.phone_number}`
                                    _hash['value'] = val.phone_number
                                    _hash['profile_name'] = val.hasOwnProperty('name') && val.name ? val.name : "";
                                    _hash['phone_number'] = val.hasOwnProperty('phone_number') && val.phone_number ? val.phone_number : "";
                                    _hash['last_chat_initiated_at'] = val.hasOwnProperty('last_chat_initiated_at') && val.last_chat_initiated_at ? val.last_chat_initiated_at : "";

                                    contactArr.push(_hash);
                                })
                                setadditionalContactsOptions(contactArr)
                            } else {
                                setadditionalContactsOptions([])
                            }
                        } else {
                            Utility.toastNotifications("Something went wrong !", "Error", "error")
                        }
                        loaderStateFalse();
                    }).catch((error) => {
                        loaderStateFalse();
                    });
                }
            } else {
                setPhoneNumber("");
                // setPhoneNumberError("Required field");
                setParamsData({})
                setChatHistoryInput("")
                setTwentyfourshoursover(false)
                // Utility.toastNotifications("Required field", "Warning", "warning")
            }
        }
    }

    const phoneNoProceed = () => {
        if (selectedGroupContact.length == 1 && selectedGroupContact[0].type == 'contact') {
            setChatHistoryData([])

            if (props.selectedPhones && props.selectedPhones?.length > 0) {
                setPhoneNumber(selectedGroupContact[0].value.replace("+", ""))
            } else {
                setPhoneNumber(selectedGroupContact[0].value)
            }
        } else {
            setChatHistoryData([])
            setPhoneNumber('')
        }
        setUploadFilePopupFlag(false)
    }

    const handleOverflowClick = () => {
        setModalOpen(true);
    };

    const closeModal = () => {
        setModalOpen(false);
    };

    useEffect(() => {
        if (searchingData.length > 2) {
            getGroupAndContactData()
        }
    }, [searchingData])

    const getGroupAndContactData = () => {
        const { loaderStateTrue, loaderStateFalse } = props;
        loaderStateTrue();
        let filters = {};
        //let filter_op = {};
        let globalQueryParamshash = {};
        if (props.searchValue != "") {
            globalQueryParamshash['search_attr'] = searchingData
            //filter_op = Object.assign(filter_op, { "search_attr": "substring" });
        }
        // if (Object.keys(filter_op).length > 0) {
        //     filters["filter_op"] = JSON.stringify(filter_op);
        // }
        filters['filters'] = JSON.stringify(globalQueryParamshash)

        getGroupAndContactList(filters, "get").then((response) => {
            loaderStateFalse();
            // console.log("response==========", response)
            if (response.success) {
                let groupArr = []
                let contactArr = []
                if (response.data.group_data.length > 0) {
                    response.data.group_data.map((val, idx) => {
                        let group_hash = {}
                        group_hash['label'] = `${val.name}${val.hasOwnProperty('members_count') && val.members_count && Number(val.members_count) > 0 ? `(${val.hasOwnProperty('members_count') && val.members_count && Number(val.members_count) > 1 ? 'contacts:' : 'contact:'}${val.hasOwnProperty('members_count') && val.members_count ? val.members_count : '0'})` : '(No contact)'}`
                        group_hash['value'] = val.id
                        group_hash['type'] = "group"
                        groupArr.push(group_hash);
                    })
                }
                if (response.data.individual_customer_data.length > 0) {
                    response.data.individual_customer_data.map((val, idx) => {
                        let _hash = {}
                        _hash['label'] = val.name && val.name != "" ? `${val.phone_number.trim().startsWith('+') ? '' : `+`}${val.phone_number}(${val.name})` : `${val.phone_number.trim().startsWith('+') ? '' : `+`}${val.phone_number}`
                        _hash['value'] = val.phone_number
                        _hash['type'] = "contact"
                        contactArr.push(_hash);
                    })
                }
                setGropuAndPhoneNumberList([...groupArr, ...contactArr])
            } else {
                Utility.toastNotifications("Something went wrong !", "Error", "error")
            }
            loaderStateFalse();
        }).catch((error) => {
            loaderStateFalse();
        });
    }

    const reEngageFn = () => {
        let valid = reEngageValidFn()
        if (valid) {
            // setReEngageModalFlag(true);
            // templateCardDesignList();
            if (props.allReadyChooseTemplate && Object.keys(props.chooseTemplateData).length > 0) {
                setReEngageModalFlag(true);
            } else {
                setMobileTemplateListData([]);
                setNoRecordFoundMsg('')
                setSelectedTabTemplate("broadcast_template");
                setCardTemplateOffsets(0)
                setCardTemplateLimits(10)
                templateCardDesignList();
                setReEngageModalFlag(true);
            }
        }
    }

    const reEngageValidFn = () => {
        let valid = true
        if (activeTab === 'singleUser') {
            let phoneValidate = HomeUtility.validate_Phone_Number_without_plus(phoneNumber);
            if (!phoneValidate && Utility.isCountryCodePhoneNumber(paramsData.phone_number)) {
                valid = true;
                // Utility.toastNotifications("Please enter contact number", "Warning", 'warning')
            } else if (!phoneValidate) {
                valid = false;
                Utility.toastNotifications("Please enter contact number", "Warning", 'warning')
            }
        } else if (activeTab === 'userGroup') {
            if (selectedGroupContact.length == 0) {
                valid = false;
                Utility.toastNotifications("Please select group", "Warning", 'warning')
            }
        }

        return valid;
    }
    const reEngageCheckFn = () => {
        let valid = true
        if (activeTab === 'singleUser') {
            let phoneValidate = HomeUtility.validate_Phone_Number_without_plus(phoneNumber);
            if (!phoneValidate) {
                valid = false;
                //Utility.toastNotifications("Please enter contact number", "Warning", 'warning')
            }
        }

        return valid;
    }

    const phoneNoProceesVaildFn = () => {
        let valid = false;
        if (selectedGroupContact.length == 1 && selectedGroupContact[0].type == 'contact') {
            valid = true;
        }
        return valid;
    }

    const clearChatFn = () => {
        setChatHistoryDeleteConfirmationFlag(true)
    }
    const chatHistoryDeleteConfirmationConfirmFn = () => {
        chatHistoryDeleteApiFn();
    }
    const chatHistoryDeleteConfirmationCancleFn = () => {
        setChatHistoryDeleteConfirmationFlag(false);
    }
    const chatHistoryDeleteConfirmationCloseFn = () => {
        setChatHistoryDeleteConfirmationFlag(false);
    }

    const chatHistoryDeleteApiFn = () => {
        const { loaderStateTrue, loaderStateFalse } = props;
        loaderStateTrue();
        let data = {}
        data['phone_number'] = [paramsData?.phone_number];
        data['only_chat_history'] = true;
        clearChatHistory(data).then((response) => {
            if (response.success) {
                setChatHistoryData([])
                chatHistoryDeleteConfirmationCloseFn();
                Utility.toastNotifications(response.data[0].message, "Success", "success")
            } else {
                Utility.toastNotifications(response.data[0].message, "Error", "error")
            }
            loaderStateFalse();
        }).catch((error) => {
            console.error("************error*************", error)
            if (error) {
            }
            loaderStateFalse();
            if (error.message == "Network Error") {
            }
        });
    }

    const clearContactFn = () => {
        // console.log("clearContactFn")
        setSelectedUser({})
        setDisableFilter(false)
        setParamsData({})
        setChatHistoryData([])
        setPhoneNumber("91")
        setTwentyfourshoursover(false);
        setUploadFilePopupFlag(false)
    }

    // const PhoneNumberValidator = (phone_number) => {
    //     const countryCodes = [
    //         "IN", "US", "CA", "GB", "AU", "DE", "FR", "IT", "ES", "BR",
    //         "MX", "JP", "KR", "CN", "RU", "ZA", "NG", "EG", "TR", "SA",
    //         "AR", "CL", "CO", "NL", "BE", "SE", "CH", "NO", "DK", "FI",
    //         "GR", "PL", "PT", "AT", "CZ", "HU", "RO", "NZ", "IE", "SG",
    //         "MY", "TH", "VN", "PH"
    //     ];
    //     if (!/^\+?\d+$/.test(phone_number)) {
    //         return { success: false, message: "Invalid input: phone number must contain only digits, optionally prefixed by '+'." };
    //     }
    //     let valid_numbers = []
    //     for (let code of countryCodes) {
    //         console.log('code==============', code)
    //         console.log('phone_number==============', phone_number)
    //         const parsedNumber = parsePhoneNumberFromString(phone_number, code);
    //         if (parsedNumber && parsedNumber.isValid()) {
    //             //return { success: true, data: parsedNumber.formatInternational() };
    //             valid_numbers.push({ label: parsedNumber.formatInternational(), value: parsedNumber.formatInternational() })
    //         }
    //     }
    //     if (valid_numbers.length > 0) {
    //         return { success: true, data: valid_numbers };
    //     }
    //     return { success: false, message: "Invalid phone number" };
    // }

    const PhoneNumberValidator = (phone_number) => {
        const countryCodes = [
            "IN", "US", "CA", "GB", "AU", "DE", "FR", "IT", "ES", "BR",
            "MX", "JP", "KR", "CN", "RU", "ZA", "NG", "EG", "TR", "SA",
            "AR", "CL", "CO", "NL", "BE", "SE", "CH", "NO", "DK", "FI",
            "GR", "PL", "PT", "AT", "CZ", "HU", "RO", "NZ", "IE", "SG",
            "MY", "TH", "VN", "PH"
        ];

        if (!/^\+?\d+$/.test(phone_number)) {
            return { success: false, message: "Invalid input: phone number must contain only digits, optionally prefixed by '+'." };
        }

        const uniqueNumbers = new Set();
        const valid_numbers = [];

        for (let code of countryCodes) {
            const parsedNumber = parsePhoneNumberFromString(phone_number, code);
            if (parsedNumber && parsedNumber.isValid()) {
                const formattedNumber = parsedNumber.formatInternational();

                // Add unique formatted numbers only
                if (!uniqueNumbers.has(formattedNumber)) {
                    uniqueNumbers.add(formattedNumber);
                    valid_numbers.push({ label: formattedNumber, value: formattedNumber.trim().replace('+', ''), 'type': "contact" });
                }
            }
        }

        if (valid_numbers.length > 0) {
            return { success: true, data: valid_numbers };
        }

        return { success: false, message: "Invalid phone number" };
    }

    // const handleOnBlurContactChange = (e) => {
    //     if (e.target.value != "") {
    //         let phoneValidate = PhoneNumberValidator(e.target.value);
    //         // console.log('e.target.value', e.target.value)
    //         // console.log('phoneValidate', phoneValidate)
    //         if (phoneValidate.success) {
    //             if (phoneValidate.data.length > 0) {
    //                 setGropuAndPhoneNumberList([...gropuAndPhoneNumberList, ...phoneValidate.data])
    //                 setTimeout(() => setIsOpen(true), 200);
    //                 // let newData = { "label": phoneValidate.data[0].label.trim(), "value": phoneValidate.data[0].value.trim().replace("+", "") };
    //                 // setSelectedGroupContact(prevData => [...prevData, newData]);
    //             }

    //             // setSelectedGroupContactError('');
    //         } else {
    //             Utility.toastNotifications(phoneValidate.message, "Error", "error")
    //         }
    //     }
    // }
    const handleOnBlurContactChange = (e) => {
        if (e.target.value != "") {
            let phoneValidate = HomeUtility.validate_Phone_Number_without_plus(e.target.value);
            if (phoneValidate) {
                let newData = { "label": e.target.value, "value": e.target.value, 'type': "contact" };
                setSelectedGroupContact(prevData => [...prevData, newData]);
            } else {
                Utility.toastNotifications("Please input valid phone number", "Error", "error")
            }
        }
    }

    const checkRolePermission = async () => {
        // let leadsRules = await UtilityGlobal.getRoleObjectBySubEventKey('notificationHistory', 'leads');
        // let opportunityRules = await UtilityGlobal.getRoleObjectBySubEventKey('notificationHistory', 'opportunity');
        // let futureOpportunityRules = await UtilityGlobal.getRoleObjectBySubEventKey('notificationHistory', 'futureOpportunity');
        // let inactiveRules = await UtilityGlobal.getRoleObjectBySubEventKey('notificationHistory', 'inactive');
        // let campaignBroadcastingRules = await UtilityGlobal.getRoleObjectBySubEventKey('notificationHistory', 'campaignBroadcasting');
        // if (checkRules.length > 0) {
        //     this.setState({
        //         checkRulesPermission: checkRules[0]?.rules
        //     })
        // }
        const permissions = ['leads', 'opportunity', 'futureOpportunity', 'inactive'];
        const updatedPermissions = { ...rolePermissions };

        for (const permission of permissions) {
            const permissionData = await UtilityGlobal.getRoleObjectBySubEventKey('notificationHistory', permission);
            if (permissionData.length > 0) {
                updatedPermissions[permission] = permissionData[0]?.rules;
            }
        }

        setRolePermissions(updatedPermissions);
    }

    // useEffect(() => {
    //     console.log("rolePermissions========", rolePermissions)
    // }, [rolePermissions])

    // console.log("permissionRulesGridMode========", props.permissionRulesGridMode)
    let permissionRulesGridMode = props.permissionRulesGridMode
    let permission_mode = permissionRulesGridMode?.length > 0 && permissionRulesGridMode[0]?.rules;

    useEffect(() => {
        if (((roleName == 'user' || roleName == 'staff') && (permission_mode == "CRUD" || permission_mode == "CUD"))) {
            setPermissionModeOnly(true)
        }
        if (permissionRulesGridMode == undefined && (!permission_mode)) {
            setPermissionModeOnly(true)
        }
    }, [props.permissionRulesGridMode])


    const setSelectedEmojiCallBackFn = (value, selectedItem) => {
        // console.log(value)
        if (value != "") {
            let data = {};
            data["reaction"] = {
                "reaction_emoji": value,
                "wa_id": selectedItem?.wa_id
            }
            data["phone_number"] = selectedItem?.phone_number
            data["profile_name"] = selectedItem?.profile_name
            data["followup_by"] = selectedItem?.followup_by
            setCurrentPage(1)
            props.loaderStateTrue();
            followUpPost(data).then((response) => {
                if (response.success) {
                    if (response.message && response.message != "") {
                        Utility.toastNotifications(response.message, "Success", "success")
                    }
                    reactionUpdateInChatList(response?.data?.id, response?.data);
                } else {
                    Utility.toastNotifications("Something went wrong !", "Error", "error")
                }
                props.loaderStateFalse();
            }).catch((error) => {
                console.log('----------error-------', error);

                props.loaderStateFalse();
            });
        }
    }

    const reactionUpdateInChatList = (Id, newValue) => {
        let chatHistoryDataTemp = [...chatHistoryData];
        let objectToUpdate = chatHistoryDataTemp.find(item => item.id === Id);
        objectToUpdate = newValue;
        objectToUpdate.contextMenu = {
            visible: false,
            x: 0,
            y: 0
        };
        let updatedArray = chatHistoryDataTemp.map(item =>
            item.id === Id ? objectToUpdate : item);
        setChatHistoryData(updatedArray)
    }

    const updateChatHistoryCallBackFn = (Id, newValue) => {
        let chatHistoryDataTemp = [...chatHistoryData];
        let objectToUpdate = chatHistoryDataTemp.find(item => item.id === Id);
        objectToUpdate = newValue;
        objectToUpdate.contextMenu = {
            visible: false,
            x: 0,
            y: 0
        };
        let updatedArray = chatHistoryDataTemp.map(item =>
            item.id === Id ? objectToUpdate : item);
        setChatHistoryData(updatedArray)
    }

    useEffect(() => {
        // Scroll to the bottom on initial render
        if (chatContainerRef.current && !scrollInFirstTime && !scrollAtEnd && chatHistoryData.length > 0) {
            setScrollAtEnd(true)
        }
    }, [chatHistoryData]);

    useEffect(() => {
        if (scrollAtEnd && chatContainerRef.current) {
            chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
            setScrollAtEnd(false);
        }
    }, [scrollAtEnd])

    const messageCount = props.version?.find(item => item.label.split(' ')[0] === props.userCredentials?.user_details?.version)?.message_count;

    return (
        <>
            <div className={activeTab == "userGroup" ? "header chatHistoryHeader quick_message userGroupHeader" : "header chatHistoryHeader quick_message"}>
                {props.value != 11 && props.value != 12 && !props.hideShowData && (
                    <div className={activeTab == "userGroup" ? "leftPanelBox leftPanelUserGroup" : "leftPanelBox"}>
                        {/* <div className='PhoneNumberFlex'>
                        <PhoneInput
                            country={selectedCountryCode}
                            value={phoneNumber || ""}
                            onChange={(e, country) => { handelChangePhoneNumber(e, country) }}
                            enableSearch={true}
                            searchPlaceholder="Search countries"
                        />
                        <button onClick={() => { getUserDataFromPhoneNumberApiFn() }} className='sendBtnBox'>
                            <i className="fa fa-arrow-right" aria-hidden="true"></i>
                        </button>
                    </div> */}
                        <div className={`tabs filterTabBoxes ${!disableFilter ? '' : 'disabledTopFiltes'}`}>
                            <div className="tab-list">
                                <div className='customDropBox'>
                                    <button
                                        onClick={() => handleTabClick(activeTab)}
                                        className="tabButton active"
                                        data-tip={activeTab === 'singleUser' ? 'Send Message to Individual Contact' : activeTab === 'userGroup' ? 'Send Message to Multiple Contacts or Group.' : 'Send Messeges to Multiple Contacts via Uploading Excel'}
                                        data-for="tooltip"
                                    >
                                        {activeTab === 'singleUser' && <i className="fa fa-user" aria-hidden="true"></i>}
                                        {activeTab === 'userGroup' && <i className="fa fa-users" aria-hidden="true"></i>}
                                        {activeTab === 'csv' && <img src={require('../../Utility/Public/images/excelBlue.png')} className='excelBlue' />}
                                    </button>

                                    <button onClick={toggleDropdown} className="arrowButton" aria-label="Toggle Dropdown">
                                        <i className={`fa ${isDropdownOpen ? 'fa fa-sort-asc' : 'fa fa-sort-desc'}`} aria-hidden="true"></i>
                                    </button>
                                </div>
                                {isDropdownOpen && (
                                    <div className="dropdown dropdownSelectionBox" ref={dropdownRef}>
                                        {activeTab !== 'singleUser' && (
                                            <OverlayTrigger overlay={<Tooltip>Send Message to Individual Contact</Tooltip>}>
                                                <button onClick={() => handleTabClick('singleUser')} className="tabButton"
                                                >
                                                    <i className="fa fa-user" aria-hidden="true"></i>
                                                    <span>Message</span>
                                                </button>
                                            </OverlayTrigger>
                                        )}
                                        {activeTab !== 'userGroup' && (
                                            <OverlayTrigger overlay={<Tooltip>Send Message to Multiple Contacts or Group.</Tooltip>}>
                                                <button onClick={() => handleTabClick('userGroup')} className="tabButton">
                                                    <i className="fa fa-users" aria-hidden="true"></i>
                                                    <span>Message Multiple.</span>
                                                </button>
                                            </OverlayTrigger>
                                        )}
                                        {activeTab !== 'csv' && (
                                            <OverlayTrigger overlay={<Tooltip>Send Messeges to Multiple Contacts via Uploading Excel</Tooltip>}>
                                                <button onClick={() => handleTabClick('csv')} className="tabButton">
                                                    {/* <i className="fa fa-file" aria-hidden="true"></i> */}
                                                    <img src={require('../../Utility/Public/images/excelGray.png')} className='excelGray' />
                                                    <img src={require('../../Utility/Public/images/excelBlue.png')} className='excelBlue' />
                                                    <span>Messeges using Excel</span>
                                                </button>
                                            </OverlayTrigger>
                                        )}
                                    </div>
                                )}
                                <ReactTooltip id="tooltip" place="top" />
                                <ReactTooltip id="tooltip2" place="top" />
                            </div>
                            <div className="tab-content">
                                {activeTab === 'singleUser' && <>
                                    {/* <div className="dropdowninnerbox additional_contacts_inner">
                                    <ErrorBoundary title="AutosuggestComponent Error">
                                        <AutosuggestComponent
                                            handleOnChange={(e) => { handleChangeAdditionalContact(e) }}
                                            handleOnInputChange={(e) => { handleInputChangeAdditionalContact(e) }}
                                            handleOnBlurChange={(e) => { handleOnBlurChange(e) }}
                                            options={additionalContactsOptions}
                                            selectedValue={additionalContactSelectedValue}
                                            name=''
                                            isMulti={false}
                                            placeholder="Contacts"
                                            isDisabled={props.globalChat ? false : true}
                                            isSearchable={true}
                                        />
                                    </ErrorBoundary>
                                </div> */}
                                    {!Utility.isCountryCodePhoneNumber(paramsData?.phone_number) &&
                                        <div className='PhoneNumberFlex dropdowninnerbox additional_contacts_inner' ref={inputContainerRef}>
                                            <PhoneInput
                                                country={selectedCountryCode}
                                                value={phoneNumber || ""}
                                                onChange={(e, country) => { handelChangePhoneNumber(e, country, 'single_phone') }}
                                                enableSearch={true}
                                                searchPlaceholder="Search countries"
                                                onFocus={(e) => {
                                                    // console.log('e---->', e)
                                                    setShowSuggestions(true)
                                                }}
                                            // onBlur={() => setShowSuggestions(false)}
                                            />
                                            {showSuggestions && (
                                                <div className="suggestions-box">
                                                    {additionalContactsOptions.map((suggestion, index) => (
                                                        <div
                                                            key={index}
                                                            className="suggestion"
                                                            onClick={() => handleClickSuggestionContact(suggestion)}
                                                        >
                                                            {/* {suggestion.label} */}
                                                            {suggestion.label && suggestion.label.length >= 33 ? <OverlayTrigger overlay={<Tooltip>{suggestion.label}</Tooltip>}>
                                                                <span >{(suggestion.label).substring(0, 30) + "..."}</span>
                                                            </OverlayTrigger> :
                                                                suggestion.label
                                                            }
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                            {Object.keys(paramsData).length == 0 ? <button onClick={() => { getUserDataFromPhoneNumberApiFn() }} className='sendBtnBox'>
                                                <i className="fa fa-arrow-right" aria-hidden="true"></i>
                                            </button> : null}
                                        </div>
                                    }
                                </>}
                                {activeTab === 'userGroup' && <>
                                    {/* <div className='select_box_innner_content'>
                                    <ErrorBoundary title="AutosuggestComponent Error">
                                        <AutosuggestComponent
                                            handleOnChange={(e) => { handleChangeGroupContactFn(e) }}
                                            options={groupContactsData}
                                            selectedValue={selectedGroupContact}
                                            name=''
                                            isMulti={false}
                                            placeholder="Group"
                                            isDisabled={props.globalChat ? false : true}
                                            isSearchable={true}
                                        />
                                    </ErrorBoundary>
                                </div> */}
                                    <div className='select_box_innner_content'>
                                        <ErrorBoundary title="AutosuggestComponent Error">
                                            <Select
                                                options={gropuAndPhoneNumberList}
                                                value={selectedGroupContact}
                                                onChange={(e) => handelChangePhoneNumber(e, {}, 'multiselect')}
                                                onInputChange={(inputValue) => handelChangePhoneNumber(inputValue, {}, 'typing')}
                                                onBlur={(e) => {
                                                    handleOnBlurContactChange(e);
                                                }}
                                                isMulti={true}
                                                components={{
                                                    ValueContainer: CustomValueContainer,
                                                    Menu
                                                }}
                                                handleOverflowClick={handleOverflowClick}
                                                setParamsData={setParamsData}
                                                isClearable={true}
                                                closeMenuOnSelect={false}
                                                openMenuOnFocus={true}
                                                placeholder="Search Groups & Contacts..."
                                                //menuHeader="Contacts"
                                                defaultMenuIsOpen={true}
                                                // oncloseMenu={(e) => onCloseMenuGroupPhoneNumber()}
                                                // ref={(scope) => { selectRefGroupPhoneNumber = scope }}
                                                isDisabled={false}
                                                isSearchable={true}
                                                // menuPosition="fixed"
                                                // hideSelectedOptions={false}
                                                classNamePrefix="group_common_dropdown_box commonDropdown"
                                                menuIsOpen={isOpen}
                                                onMenuOpen={() => setIsOpen(true)}
                                                onMenuClose={() => setIsOpen(false)}
                                            />
                                        </ErrorBoundary>
                                        {phoneNoProceesVaildFn() && Object.keys(paramsData).length == 0 ? <button onClick={() => { phoneNoProceed() }} className='sendBtnBox'>
                                            <i className="fa fa-arrow-right" aria-hidden="true"></i>
                                        </button> : null}
                                    </div>
                                </>}
                                {activeTab === 'csv' && <></>}
                            </div>
                        </div>
                        {Object.keys(paramsData).length > 0 ?
                            <div className='user_view_profile_sec'>
                                <div className='name_phno_sec'>
                                    <div className='name_sec'>
                                        {paramsData.profile_name && paramsData.profile_name != "" ?
                                            <>
                                                {paramsData.profile_name.length >= 30 ?
                                                    <OverlayTrigger overlay={<Tooltip>{paramsData.profile_name}</Tooltip>}>
                                                        <span>{(paramsData.profile_name).substring(0, 27) + "..."}</span>
                                                    </OverlayTrigger>
                                                    : <span>{paramsData.profile_name}</span>
                                                }
                                            </>
                                            : <span>NA</span>
                                        }
                                        <span>
                                            {isLiveChat == 1 && (
                                                <Badge variant='success' className='live_chat_badge'>
                                                    <OverlayTrigger overlay={<Tooltip>Active Until : {Timezone.formatDate(liveChatEndAt, props.localTimeZoneName)}</Tooltip>}>
                                                        <span style={{ cursor: 'pointer' }}>Live Chat</span>
                                                    </OverlayTrigger>
                                                </Badge>
                                            )}
                                        </span>
                                    </div>
                                    {Utility.isCountryCodePhoneNumber(paramsData?.phone_number) ?
                                        <div className='phno_sec'>{paramsData.phone_number && paramsData.phone_number || ''}</div>
                                        :
                                        <div className='phno_sec'>{paramsData.phone_number && Utility.formatPhoneNumber(paramsData.phone_number.includes("+") ? paramsData.phone_number : `+${paramsData.phone_number}`)}</div>
                                    }
                                </div>
                            </div>
                            :
                            <>
                                {Object.keys(selectedUser).length > 0 && <div className='user_view_profile_sec'>
                                    <div className='name_phno_sec'>
                                        <div className='name_sec'>
                                            {selectedUser.profile_name && selectedUser.profile_name != "" ?
                                                <span>{selectedUser.profile_name}</span> : <span>NA</span>
                                            }
                                        </div>
                                        <div className='phno_sec'>{selectedUser.phone_number && Utility.formatPhoneNumber(selectedUser.phone_number.includes("+") ? selectedUser.phone_number : `+${selectedUser.phone_number}`)}</div>
                                    </div>
                                </div>
                                }
                            </>}
                        {disableFilter && Object.keys(selectedUser).length > 0 ? <div className='clearNameValue'>
                            <OverlayTrigger overlay={<Tooltip>Clear selected contact</Tooltip>}>
                                <img src={require('../../Utility/Public/images/close-button.png')} onClick={() => { clearContactFn() }} />
                            </OverlayTrigger>
                        </div> : null}
                        {/* <div>
                        <div className="countersradiobox radio_label">
                            <div className="radio_btn_content">
                                <label className={!twentyfourshoursover && Object.keys(paramsData).length > 0 ? "custom-radio-container" : "custom-radio-container disabledTextMessage"}>Text Message
                                    <input type="radio" name="message" value="following_events"
                                        onChange={(e) => handelChangeMessageType(e, "text_message")}
                                        checked={templateMessageType == "text_message" ? true : false}
                                    //disabled={!twentyfourshoursover && Object.keys(paramsData).length > 0 ? true : false}
                                    />
                                    <span className="checkmark"></span>
                                </label>
                                <label className={!twentyfourshoursover && enableFlag ? "custom-radio-container" : "custom-radio-container disabledTemplateMessage"}>Template Message
                                    <input type="radio" name="message" value="this_event"
                                        onChange={(e) => handelChangeMessageType(e, "template_message")}
                                        checked={templateMessageType == "template_message" ? true : false}
                                    //disabled={!twentyfourshoursover && Object.keys(paramsData).length > 0 ? true : false}
                                    />
                                    <span className="checkmark"></span>
                                </label>
                            </div>
                        </div>
                    </div> */}
                    </div>
                )}
                {props.value == 11 && Object.keys(selectedUser).length > 0 &&
                    <div className='user_view_profile_sec'>
                        <div className='name_phno_sec'>
                            <div className='name_sec'>
                                {selectedUser.profile_name && selectedUser.profile_name != "" ?
                                    <span>{selectedUser.profile_name}</span> : <span>NA</span>
                                }
                            </div>
                            <div className='phno_sec'>{selectedUser.phone_number && selectedUser.phone_number}</div>
                        </div>
                    </div>
                }
                {props.value == 12 && Object.keys(selectedUser).length > 0 &&
                    <div className='user_view_profile_sec'>
                        <div className='name_phno_sec'>
                            <div className='name_sec'>
                                {selectedUser.profile_name && selectedUser.profile_name != "" ?
                                    <span>{selectedUser.profile_name}</span> : <span>NA</span>
                                }
                            </div>
                            <div className='phno_sec'>{selectedUser.phone_number && Utility.formatPhoneNumber(`+${selectedUser.phone_number}`)}</div>
                        </div>
                    </div>
                }
                {props.hideShowData && Object.keys(selectedUser).length > 0 &&
                    <div className='user_view_profile_sec'>
                        <div className='name_phno_sec'>
                            <div className='name_sec'>
                                {selectedUser.profile_name && selectedUser.profile_name != "" ?
                                    <span>{selectedUser.profile_name}</span> : <span>NA</span>
                                }
                            </div>
                            <div className='phno_sec'>{selectedUser.phone_number}</div>
                        </div>
                    </div>
                }

                <div className={!twentyfourshoursover && Object.keys(paramsData).length > 0 ? "agentModeSection" : "agentModeSection disabled"}>

                    {/* {Object.keys(paramsData).length > 0 ?
                        <div className='user_view_profile_sec'>


                            <div className="user_profile_name_icon" style={{

                                backgroundColor: getRandomBackgroundColor(`${paramsData.profile_name && user_last_name != undefined ? `${user_first_name} ${user_last_name}` : paramsData.profile_name && user_last_name == undefined && `${user_first_name}`}`),
                                color: getRandomTextColor(),
                            }}>

                                {paramsData.profile_name && user_first_name && (!user_last_name || user_last_name === "") ? firstInitial : `${firstInitial}${lastInitial}`}
                                {!firstInitial?.trim() && !lastInitial?.trim() && 'NA'}
                            </div>

                            <div className='name_phno_sec'>
                                <div className='name_sec'>
                                    {paramsData.profile_name && paramsData.profile_name != "" ?
                                        <span>{paramsData.profile_name}</span> : <span>NA</span>
                                    }
                                    <span>
                                        {isLiveChat == 1 && (
                                            <Badge variant='success' className='live_chat_badge'>
                                                <OverlayTrigger overlay={<Tooltip>Active Until : {Timezone.formatDate(liveChatEndAt, props.localTimeZoneName)}</Tooltip>}>
                                                    <span style={{ cursor: 'pointer' }}>Live Chat</span>
                                                </OverlayTrigger>
                                            </Badge>
                                        )}
                                    </span>
                                </div>
                                <div className='phno_sec'>{paramsData.phone_number && Utility.formatPhoneNumber(`+${paramsData.phone_number}`)}</div>
                            </div>
                        </div>
                        : null} */}
                    {activeTab == "singleUser" && props.value != 11 && props.value != 12 && !props.hideShowData &&
                        <div className="livemode_content">
                            <span>Live Chat</span>
                            <span className='toggleSwitchBox agentMode'>
                                <div className='switch_btn_customize' data-tip="Enable this mode when you wanted to take control from Whatsapp Bot">
                                    <BootstrapSwitchButton
                                        onlabel='On'
                                        onstyle='success'
                                        offlabel='Off'
                                        offstyle='danger'
                                        style='w-60 mx-2'
                                        checked={checkedLiveMode}
                                        onChange={(checked) => !twentyfourshoursover && Object.keys(paramsData).length > 0 ? handleChangeInboxMode(checked) : null}
                                        disabled={!twentyfourshoursover && Object.keys(paramsData).length > 0 ? true : false}
                                    />
                                </div>
                            </span>
                        </div>
                    }
                    {props.value != 11 && props.value != 12 && !props.hideShowData && Object.keys(paramsData).length > 0 && chatHistoryData.length > 0 && (permissionModeOnly || (roleName == 'admin')) ? <div className="clearchat_content">
                        <span onClick={() => { clearChatFn() }}>
                            <OverlayTrigger overlay={<Tooltip>Clear chat history</Tooltip>}>
                                <img src={require('../../Utility/Public/images/deleteChat.png')} className="deleteChat" />
                            </OverlayTrigger>
                        </span>
                    </div> : null}
                    {props.value != 11 && props.value != 12 && !props.hideShowData && activeTab == "singleUser" &&
                        <div className="refresh_chat_btn"><button className="buttonload" onClick={() => { !twentyfourshoursover && Object.keys(paramsData).length > 0 ? loadChat() : null }} data-tip="Refresh chat"><i className="fa fa-refresh"></i>
                        </button>
                            <ReactTooltip place="bottom" />
                        </div>
                    }
                </div>
            </div>

            <div className="body">
                <Suspense fallback={<div>Loading Component...</div>}>
                    {Chatpanel ? <Chatpanel
                        chatHistoryData={chatHistoryData}
                        handleScroll={handleScroll}
                        messageRef={messageRef}
                        updateStarMark={updateStarMark}
                        chatContainerRef={chatContainerRef}
                        messageActionCallBack={messageActionCallBack}
                        messageActionCallBackOuteSideClick={messageActionCallBackOuteSideClick}
                        setActionClick={setActionClick}
                        setSelectedEmoji={setSelectedEmojiCallBackFn}
                        updateChatHistoryCallBackFn={updateChatHistoryCallBackFn}
                        value={props.value}
                    /> : <div>Loading Chatpanel...</div>}
                </Suspense>
            </div>



            {props.value != 11 && !props.hideShowData && props.userCredentials?.user_details.hasOwnProperty('subscription_ended') && props.userCredentials?.user_details.subscription_ended != null && props.userCredentials?.user_details.subscription_ended == false ? <div className="footer chatHistoryFooter">
                {
                    roleName == "admin" || roleName == "user" ?
                        <>
                            {/* {twentyfourshoursover ? */}
                            <div className='reEngageSec_message'>
                                {/* <span className='message_text'>24 hour conversation window is closed. Send message template to re-engage him.</span> */}
                                {/* <div className='reEngageSecParent'>
                                    <button className='reEngageButton' data-tip="Re-Engage" onClick={reEngageFn}>Send Template Message</button>
                                    <OverlayTrigger overlay={<Tooltip>You're seeing this Re-engage button because this customer hasn't interacted with you in the last 24 hours. To reconnect with them on this platform, send a message now. We're here to help you re-engage and keep the conversation going!</Tooltip>} placement='top'>
                                        <span className='info'>
                                            <i className="fa fa-info-circle" aria-hidden="true"></i>
                                        </span>
                                    </OverlayTrigger>
                                </div> */}
                            </div>
                            {/* {!twentyfourshoursover && Object.keys(paramsData).length > 0 ? */}
                            <div className={!twentyfourshoursover && Object.keys(paramsData).length > 0 ? 'sendBoxInnerSection' : 'sendBoxInnerSection disabledBox'}>
                                <ErrorBoundary title="ChatHistoryFooter Error">
                                    {/* <div className='fileUploadButtonSec'>
                                        <button className='fileUploadButton' data-tip="File Upload" onClick={fileUploadFN}>  {fileUploadFNFlag ? <span>-</span> : <span>+</span>} File Upload <span style={{ color: 'red', fontSize: '13px' }}>(* Pdf, Image, Csv only )</span> </button>
                                    </div> */}
                                    {/* {fileUploadFNFlag ?
                                        <div className='fileUploadContainer'>
                                            <ErrorBoundary title="MultipleFileUpload Error">
                                                <MultipleFileUpload
                                                    documentObjName={chatHistoryDocumentObjName}
                                                    onDrop={chatHistoryDropDocumentFileChange}
                                                    onChange={chatHistoryUploadMultiDocumentFile}
                                                    // submit={this.props.documentSubmit}
                                                    documentObject={chatHistoryDocumentObject}
                                                    removeDoc={chatHistoryRemoveDoc}
                                                />
                                            </ErrorBoundary>
                                        </div>
                                        : null} */}
                                    <Overlay target={targetFileUpload.current} show={uploadFilePopupFlag} placement="left">
                                        {(props) => (
                                            <Tooltip id="overlayFileUpload" className='uploadFilePopupDialog chatModal' {...props}>
                                                <div className='fileUploadContainer'>
                                                    <button onClick={() => closeUploadFilePopup()} className='closeBtn'></button>
                                                    <ErrorBoundary title="MultipleFileUpload Error">
                                                        <MultipleFileUpload
                                                            documentObjName={chatHistoryDocumentObjName}
                                                            onDrop={chatHistoryDropDocumentFileChange}
                                                            onChange={chatHistoryUploadMultiDocumentFile}
                                                            // submit={this.props.documentSubmit}
                                                            documentObject={chatHistoryDocumentObject}
                                                            removeDoc={chatHistoryRemoveDoc}
                                                            fileInputKey={fileInputKey}
                                                        />
                                                    </ErrorBoundary>
                                                </div>
                                            </Tooltip>
                                        )}
                                    </Overlay>

                                    {!twentyfourshoursover && Object.keys(paramsData).length > 0 ?
                                        <></> :
                                        <div className='inputPlaceHolder'><span>{activeTab == "singleUser" && Object.keys(paramsData).length > 0 && "24 hour conversation window is closed. Send message template to re-engage the user."}</span></div>
                                    }
                                    <ErrorBoundary title="ChatHistoryInput Error">
                                        <div className='inputWithTemplate'>
                                            <Suspense fallback={<div>Loading Component...</div>}>
                                                {ChatHistoryInputModal ? <ChatHistoryInputModal
                                                    chatHistoryInputFn={!twentyfourshoursover && Object.keys(paramsData).length > 0 ? chatHistoryInputFn : null}
                                                    chatHistorySendButttonFn={!twentyfourshoursover && Object.keys(paramsData).length > 0 ? chatHistorySendButttonFn : null}
                                                    chatHistoryInput={chatHistoryInput}
                                                    //emojiShowContentFn={!twentyfourshoursover && Object.keys(paramsData).length > 0 ? emojiShowContentFn : null}
                                                    emojiShowContentFn={!twentyfourshoursover && Object.keys(paramsData).length > 0 ? emojiShowContentFn : () => { }}
                                                    chatHappyIcon={true}
                                                    happyCommonIcon={false}
                                                /> : <div>Loading ...</div>}
                                            </Suspense>
                                            <div className={"reEngageSec_message fileUpload"} ref={targetFileUpload}>
                                                <div className='reEngageSecParent'>
                                                    <OverlayTrigger overlay={<Tooltip>Upload file</Tooltip>}>
                                                        <button className='reEngageButton'
                                                            onClick={() => (!twentyfourshoursover && Object.keys(paramsData).length > 0 ? fileUploadPopupFN() : null)}
                                                        ><i className="fa fa-paperclip" aria-hidden="true"></i>
                                                        </button>
                                                    </OverlayTrigger>
                                                </div>
                                            </div>

                                            <div className={twentyfourshoursover ? "reEngageSec_message reEngage" : "reEngageSec_message"}>
                                                {/* <div className={"reEngageSec_message reEngage"}> */}
                                                <div className='reEngageSecParent'>
                                                    <OverlayTrigger overlay={<Tooltip>Send Template Message</Tooltip>}>
                                                        <button className='reEngageButton'
                                                            onClick={() => reEngageFn()}
                                                        ><i className="fa fa-file-text-o" aria-hidden="true"></i>
                                                        </button>
                                                    </OverlayTrigger>
                                                </div>
                                            </div>
                                        </div>
                                    </ErrorBoundary>


                                </ErrorBoundary>

                            </div>
                            {/* : null} */}

                        </> : <></>
                }
            </div> : null}


            <ErrorBoundary title="ModalGlobal Error">
                <ModalGlobal
                    show={reEngageModalFlag}
                    onHide={closeReEngageModal}
                    title={<div className='templateModalTitle'>
                        <div className={messagesViewClickStatus ? "addSpace templateNameBox" : "templateNameBox"}>
                            {activeTab == 'singleUser' && <>
                                {Object.keys(paramsData).length > 0 ?
                                    <span className='phoneNumber'>{`${paramsData.profile_name ? paramsData.profile_name : 'NA'} (${paramsData.phone_number && Utility.formatPhoneNumber(`+${paramsData.phone_number}`) || paramsData.phone_number})`}</span>
                                    : <span className='phoneNumber'>{phoneNumber}</span>}
                            </>}
                            {!messagesViewClickStatus ?
                                <span className={activeTab != 'singleUser' ? "templateBox otherUser" : "templateBox"}>Choose Template</span> :
                                <span className={activeTab != 'singleUser' ? "" : "sendTemplate"}>Send Message</span>}

                            {["v4"].includes(props.userCredentials?.user_details?.version) && messagesViewClickStatus ?
                                <div style={{ fontSize: "10px" }}>{`Your daily message limit is ${messageCount}. Messages beyond this limit will not be delivered. Please upgrade your plan for unlimited access`}</div>
                                : null
                            }
                        </div>
                        {!messagesViewClickStatus && (
                            <div className='card_list_message_view'>
                                <OverlayTrigger
                                    rootClose={true}
                                    trigger="click"
                                    placement="bottom"
                                    overlay={
                                        <Popover className='card_list_message_view_fixedBoxInner'>
                                            <Popover.Content>
                                                <div className={`fixedBox ${selectedView === 'card_view' ? 'selected' : ''}`}
                                                    onClick={() => setSelectedView('card_view')}
                                                >
                                                    <span>Card View</span>
                                                    <span>
                                                        {selectedView === 'card_view' ?
                                                            <img src={require('../../Utility/Public/images/card_view_blue.png')} className="gridviewIcon" /> :
                                                            <img src={require('../../Utility/Public/images/card_view.png')} className="gridviewIcon" />}
                                                    </span>
                                                </div>
                                                <div className={`fixedBox ${selectedView === 'list_view' ? 'selected' : ''}`}
                                                    onClick={() => setSelectedView('list_view')}
                                                >
                                                    <span>List View</span>
                                                    <span>
                                                        {selectedView === 'list_view' ?
                                                            <img src={require('../../Utility/Public/images/list_view_blue.png')} className="gridviewIcon" /> :
                                                            <img src={require('../../Utility/Public/images/list_view.png')} className="gridviewIcon" />
                                                        }
                                                    </span>
                                                </div>
                                                <div className={`fixedBox ${selectedView === 'message_view' ? 'selected' : ''}`}
                                                    onClick={() => setSelectedView('message_view')}
                                                >
                                                    <span>Message View</span>
                                                    <span>
                                                        {selectedView === 'message_view' ?
                                                            <img src={require('../../Utility/Public/images/message_view_blue.png')} className="gridviewIcon" /> :
                                                            <img src={require('../../Utility/Public/images/message_view.png')} className="gridviewIcon" />
                                                        }
                                                    </span>
                                                </div>
                                            </Popover.Content>
                                        </Popover>
                                    }
                                >
                                    <span className='view_text'>View <img src={require('../../Utility/Public/images/grid.png')} className="gridIcon" /></span>
                                </OverlayTrigger>
                            </div>
                        )}
                        {!messagesViewClickStatus ?
                            <div className="pageinnersearch">
                                <button type="button" className="btn btn-link search_btn_addon"><i className="fa fa-search"></i></button>
                                <ErrorBoundary title="DebounceInput Error">
                                    <DebounceInput
                                        minLength={2}
                                        debounceTimeout={500}
                                        onChange={(e) => handleUserSearchBar(e)}
                                        placeholder="Search a template"
                                        value={templateName}
                                    />
                                </ErrorBoundary>
                                {
                                    templateName.trim() != "" ?
                                        < button type="button" className="btn btn-link dropclosebtn" onClick={() => clearSearchValue()}>
                                            <img src={require('../../Utility/Public/images/dropcloseicon.png')} className="searchClearIcon" />
                                        </button>
                                        : null}
                            </div> :
                            null}
                    </div>}
                    className={`${zoominzoomoutflag + ' ' + "modalcustomize mondimension reEngageModal templateModalForChat addMoreSpace"}`}
                    //footer={true}
                    footer={false}
                    closeButton={true}
                    saveButtonLabel="Confirm"
                    saveButtonClassName="btn btn-primary delconfirmbtn"
                    onSave={confirmationForReEngageFn}
                    cancelShow={true}
                    saveShow={true}
                    onCancel={closeReEngageModal}
                    zoominButton={zoominzoomoutflag != "" ? false : true}
                    zoomoutButton={zoominzoomoutflag != "" ? true : false}
                    zoomin={zoominFunction}
                    zoomout={zoomoutFunction}
                    animation={false}
                    body={
                        <>
                            <ErrorBoundary title="ReEngageModalContent Error">
                                <Suspense fallback={<div>Loading Component...</div>}>
                                    {ReEngageModalContent ? <ReEngageModalContent
                                        selectedTimezoneType={selectedTimezoneType}
                                        handelChangeTimeZone={handelChangeTimeZone}
                                        selectedTimezoneDataError={selectedTimezoneDataError}
                                        selectedDateTimeForReEngage={selectedDateTimeForReEngage}
                                        deleteSelectedDateTimeFn={deleteSelectedDateTimeFn}
                                        handleSelectedDateTimeFnForReEngage={handleSelectedDateTimeFnForReEngage}
                                        handleChangeChooseTemplateFn={handleChangeChooseTemplateFn}
                                        selectedTemplateDataError={selectedTemplateDataError}
                                        templateListData={templateListData}
                                        selectedTemplateListData={selectedTemplateData}
                                        handleChangeDynamicHeader={handleChangeDynamicHeader}
                                        handleOnInputChangeDynamicHeaderFn={handleOnInputChangeDynamicHeaderFn}
                                        fieldTypeList={fieldTypeList}
                                        dynamicCheckboxChecked={dynamicCheckboxChecked}
                                        isPreviousVal={isPreviousVal}
                                        isPreviousValUrl={isPreviousValUrl}
                                        dynamicUrlError={dynamicUrlError}
                                        backToPreviousValBody={backToPreviousValBody}
                                        backToPreviousValUrl={backToPreviousValUrl}
                                        handleChangeDynamicBody={handleChangeDynamicBody}
                                        handleOnInputChangeDynamicBodyFn={handleOnInputChangeDynamicBodyFn}
                                        handleChangeDynamicUrl={handleChangeDynamicUrl}
                                        handleChangeMediaUrl={handleChangeMediaUrl}
                                        mediaUrl={mediaUrl}
                                        mediaUrlError={mediaUrlError}

                                        //Template message/mobile view
                                        handleSelectTabChange={handleSelectTabChange}
                                        selectedTabTemplate={selectedTabTemplate}
                                        getNextData={getNextData}
                                        mobileTemplateListData={mobileTemplateListData}
                                        noRecordFoundMsg={noRecordFoundMsg}
                                        hasMoreMobileTemplateList={hasMoreMobileTemplateList}
                                        cardTemplateOffsets={cardTemplateOffsets}
                                        cardTemplateLimits={cardTemplateLimits}

                                        csvUpload={activeTab == 'csv' ? true : false}
                                        closeReengageModalCallBackFn={closeReengageModalCallBackFn}
                                        activeTab={activeTab == 'userGroup' && selectedGroupContact.length == 1 && selectedGroupContact[0].type == 'contact' ? 'singleUser' : activeTab}
                                        selectedGroupContact={selectedGroupContact}
                                        phoneNumber={phoneNumber}
                                        messageViewClickFunction={messageViewClickFunction}
                                        allReadyChooseTemplate={props.allReadyChooseTemplate}
                                        chooseTemplateData={props.chooseTemplateData}
                                        resetCardView={resetCardView}
                                        twentyfourshoursover={twentyfourshoursover}
                                        selectedView={selectedView}
                                    /> : <div>Loading ...</div>}
                                </Suspense>

                            </ErrorBoundary>
                        </>
                    }
                />
            </ErrorBoundary>

            <ErrorBoundary title="ModalGlobal Error">
                <ModalGlobal
                    show={confirmationForReEngageModalFlag}
                    onHide={confirmationForReEngageModalHide}
                    className="modalcustomize confirmationalertmodal"
                    bodyClassName="cancelConfirmationbody"
                    headerclassName="close_btn_icon"
                    title="Please confirm?"
                    footer={false}
                    body={
                        <>
                            <ErrorBoundary title="ConfirmationAlert Error">
                                <ConfirmationAlert
                                    BodyFirstContent="Ensure that you have correctly replaced all placeholder values. Would you like to review them again?"
                                    confirmationButtonContent="Yes,I'm Confirm"
                                    cancelButtonContent="Review now"
                                    deleteConfirmButton={confirmationForReEngageConfirmButton}
                                    deleteCancleButton={confirmationForReEngageCancleButton}
                                />
                            </ErrorBoundary>
                        </>
                    }
                />
            </ErrorBoundary>

            <ErrorBoundary title="ModalGlobal Error">
                <ModalGlobal
                    show={emojiShowFlag}
                    onHide={closeEmojiContentFn}
                    className="modalcustomize emoji_modal_content"
                    headerShow={true}
                    closeButton={true}
                    footer={false}
                    title="Choose emoji"
                    bodyClassName="jobinfoModalContent"
                    headerclassName="close_btn_icon"
                    onCancel={closeEmojiContentFn}
                    body={
                        <>
                            <ErrorBoundary title="EmojiContent Error">
                                <EmojiContent
                                    showEmojiContent={emojiShowFlag}
                                    emojiSelect={emojiSelect}
                                />
                            </ErrorBoundary>
                        </>
                    }
                />
            </ErrorBoundary>

            <ErrorBoundary>
                {isModalOpen && (
                    <ModalGlobal
                        show={isModalOpen}
                        onHide={closeModal}
                        className={`${zoominzoomoutflag + ' ' + "modalcustomize control_pannel_modal more_grouplist_modal"}`}
                        title={`Groups & Contacts List`}
                        footer={false}
                        closeButton={true}
                        minimizeModal={true}
                        maximizeModal={true}
                        zoominButton={zoominzoomoutflag != "" ? false : true}
                        zoomoutButton={zoominzoomoutflag != "" ? true : false}
                        zoomin={zoominFunction}
                        zoomout={zoomoutFunction}

                        body={
                            <>
                                <div className="list_body more_btn_grouplist_modal">
                                    {selectedGroupContact.some(item => item.type === "group") && (
                                        <div className="section">
                                            <h3 className="section-title">Groups</h3>
                                            <ul className="item-list">
                                                {selectedGroupContact
                                                    .filter(item => item.type === "group")
                                                    .map(group => (
                                                        <li key={group.value} className="item">
                                                            <span className="item-label">{group.label}</span>
                                                        </li>
                                                    ))}
                                            </ul>
                                        </div>
                                    )}
                                    {selectedGroupContact.some(item => item.type === "contact") && (
                                        <div className="section">
                                            <h3 className="section-title">Contacts</h3>
                                            <ul className="item-list">
                                                {selectedGroupContact
                                                    .filter(item => item.type === "contact")
                                                    .map(contact => (
                                                        <li key={contact.value} className="item">
                                                            <span className="item-label">{contact.label}</span>
                                                        </li>
                                                    ))}
                                            </ul>
                                        </div>
                                    )}
                                </div>
                                <div className="footer_btn_sec">
                                    <button className="cancelButton" onClick={closeModal}>Cancel</button>
                                </div>
                            </>
                        }
                    />
                )}
            </ErrorBoundary>
            <ErrorBoundary title="ModalGlobal Error">
                <ModalGlobal
                    show={chatHistoryDeleteConfirmationFlag}
                    onHide={chatHistoryDeleteConfirmationCloseFn}
                    className="modalcustomize confirmationalertmodal"
                    bodyClassName="cancelConfirmationbody"
                    headerclassName="close_btn_icon"
                    title="Clear chat history"
                    footer={false}
                    headerShow={true}
                    closeButton={true}
                    body={
                        <>
                            <ErrorBoundary title="ConfirmationAlert Error">
                                <ConfirmationAlert
                                    BodyFirstContent="Do you want to clear all chat history?"
                                    confirmationButtonContent="Submit"
                                    cancelButtonContent="Cancel"
                                    deleteConfirmButton={chatHistoryDeleteConfirmationConfirmFn}
                                    deleteCancleButton={chatHistoryDeleteConfirmationCancleFn}
                                />
                            </ErrorBoundary>
                        </>
                    }

                />
            </ErrorBoundary>

        </>
    )
}

ChatHistoryModal.defaultProps = {
    globalChat: false,
    allReadyChooseTemplate: false,
    chooseTemplateData: {},
    globalChatName: "",
    lastChatInitiatedAt: "",
    groupMessage: false,
    groupMessageData: {}
}

const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
        userLoginDetails: globalState.LoginReducer.userLoginDetails,
        token: globalState.LoginReducer.token,
        localTimeZoneName: globalState.mainReducerData.localTimeZone,
        version: globalState.LoginReducer.version,
        chatDocViewId: globalState.mainReducerData.hasOwnProperty('chatDocView') && globalState.mainReducerData.chatDocView ? globalState.mainReducerData.chatDocView : []
    };
}

export default connect(mapStateToProps, { handleActiveLink, loaderStateTrue, loaderStateFalse, setChatDocView })(withRouter(ChatHistoryModal));
